/* iPhumat — Booking wizard (réservation réparation).
 * Funnel guidé : Modèle → Panne (tarif affiché) → Créneau → Coordonnées.
 * Récap sticky mis à jour à chaque étape. Submit POST vers App Proxy.
 */
(function () {
  'use strict';

  // ─── Grille tarifaire réparation (€ TTC, à partir de) ────────────────
  // Indicatif avant diagnostic. Devis ferme après inspection en atelier.
  // Familles définies pour limiter la combinatoire ; modèle → famille via FAMILY_OF.
  const PRICES = {
    'i17pro':  { screen: 309, battery:119, charging:119, water: 60, camera: 259, back: 269, software: 39 },
    'i17':     { screen: 229, battery: 99, charging: 99, water: 60, camera: 199, back: 199, software: 39 },
    se:        { screen:  79, battery: 49, charging: 59, water: 60, camera:  79, back: 79,  software: 39 },
    'i11':     { screen:  99, battery: 59, charging: 69, water: 60, camera: 109, back: 99,  software: 39 },
    'i12':     { screen:  80, battery: 75, charging: 69, water: 60, camera: 119, back: 119, software: 39 },
    'i13':     { screen: 100, battery: 75, charging: 69, water: 60, camera: 129, back: 129, software: 39 },
    'i13pro':  { screen: 159, battery: 75, charging: 79, water: 60, camera: 169, back: 179, software: 39 },
    'i14':     { screen: 139, battery: 90, charging: 79, water: 60, camera: 149, back: 149, software: 39 },
    'i14pro':  { screen: 199, battery: 90, charging: 89, water: 60, camera: 189, back: 199, software: 39 },
    'i15':     { screen: 189, battery: 89, charging: 89, water: 60, camera: 169, back: 169, software: 39 },
    'i15pro':  { screen: 269, battery: 99, charging: 99, water: 60, camera: 219, back: 229, software: 39 },
    'i16':     { screen: 209, battery: 99, charging: 99, water: 60, camera: 189, back: 189, software: 39 },
    'i16pro':  { screen: 289, battery:109, charging:109, water: 60, camera: 239, back: 249, software: 39 },
    'other':   { screen: 119, battery: 59, charging: 69, water: 60, camera: 109, back:  99, software: 39 }
  };

  const MODELS = [
    { id: 'iphone-17-pro-max',  label: 'iPhone 17 Pro Max',  fam: 'i17pro' },
    { id: 'iphone-17-pro',      label: 'iPhone 17 Pro',      fam: 'i17pro' },
    { id: 'iphone-17',          label: 'iPhone 17',          fam: 'i17'    },
    { id: 'iphone-16-pro-max',  label: 'iPhone 16 Pro Max',  fam: 'i16pro' },
    { id: 'iphone-16-pro',      label: 'iPhone 16 Pro',      fam: 'i16pro' },
    { id: 'iphone-16-plus',     label: 'iPhone 16 Plus',     fam: 'i16'    },
    { id: 'iphone-16',          label: 'iPhone 16',          fam: 'i16'    },
    { id: 'iphone-15-pro-max',  label: 'iPhone 15 Pro Max',  fam: 'i15pro' },
    { id: 'iphone-15-pro',      label: 'iPhone 15 Pro',      fam: 'i15pro' },
    { id: 'iphone-15-plus',     label: 'iPhone 15 Plus',     fam: 'i15'    },
    { id: 'iphone-15',          label: 'iPhone 15',          fam: 'i15'    },
    { id: 'iphone-14-pro-max',  label: 'iPhone 14 Pro Max',  fam: 'i14pro' },
    { id: 'iphone-14-pro',      label: 'iPhone 14 Pro',      fam: 'i14pro' },
    { id: 'iphone-14-plus',     label: 'iPhone 14 Plus',     fam: 'i14'    },
    { id: 'iphone-14',          label: 'iPhone 14',          fam: 'i14'    },
    { id: 'iphone-13-pro-max',  label: 'iPhone 13 Pro Max',  fam: 'i13pro' },
    { id: 'iphone-13-pro',      label: 'iPhone 13 Pro',      fam: 'i13pro' },
    { id: 'iphone-13',          label: 'iPhone 13',          fam: 'i13'    },
    { id: 'iphone-13-mini',     label: 'iPhone 13 mini',     fam: 'i13'    },
    { id: 'iphone-12-pro-max',  label: 'iPhone 12 Pro Max',  fam: 'i12'    },
    { id: 'iphone-12-pro',      label: 'iPhone 12 Pro',      fam: 'i12'    },
    { id: 'iphone-12',          label: 'iPhone 12',          fam: 'i12'    },
    { id: 'iphone-12-mini',     label: 'iPhone 12 mini',     fam: 'i12'    },
    { id: 'iphone-11-pro-max',  label: 'iPhone 11 Pro Max',  fam: 'i11'    },
    { id: 'iphone-11-pro',      label: 'iPhone 11 Pro',      fam: 'i11'    },
    { id: 'iphone-11',          label: 'iPhone 11',          fam: 'i11'    },
    { id: 'iphone-se-2022',     label: 'iPhone SE (2022)',   fam: 'se'     },
    { id: 'iphone-xr',          label: 'iPhone XR',          fam: 'se'     },
    { id: 'iphone-xs-max',      label: 'iPhone XS Max',      fam: 'se'     },
    { id: 'iphone-xs',          label: 'iPhone XS',          fam: 'se'     },
    { id: 'iphone-other',       label: 'Autre / plus ancien', fam: 'other' }
  ];

  // ─── Valeur reprise (aligné sur reprise-wizard.js — base mid-storage, état B) ─
  // Si tu modifies ici, modifie aussi MODELS.base dans reprise-wizard.js.
  const VALUE_BY_FAMILY = {
    se: 150, i11: 180, i12: 240, i13: 360, i13pro: 480,
    i14: 440, i14pro: 580, i15: 580, i15pro: 720, i16: 700, i16pro: 920,
    i17: 820, i17pro: 1050, other: 80
  };
  // Coefficient appliqué à la valeur reprise selon la panne (impact état).
  const VALUE_COEF_BY_ISSUE = {
    screen: 0.70, back: 0.75, charging: 0.85, camera: 0.80,
    battery: 0.88, software: 0.92, water: 0.45, other: 0.85
  };
  // Mapping upgrade : famille actuelle → liste de modèles proposés.
  // `inStock` est simulé pour l'instant — à brancher sur Shopify Admin
  // (collection → produits disponibles) via un endpoint /apps/iphumat/stock.
  const UPGRADE = {
    se: [
      { handle: 'iphone-11-reconditionne',     label: 'iPhone 11',     fromPrice: 229, inStock: true  },
      { handle: 'iphone-12-reconditionne',     label: 'iPhone 12',     fromPrice: 289, inStock: true  },
      { handle: 'iphone-13-reconditionne',     label: 'iPhone 13',     fromPrice: 379, inStock: true  }
    ],
    i11: [
      { handle: 'iphone-12-reconditionne',     label: 'iPhone 12',     fromPrice: 289, inStock: true  },
      { handle: 'iphone-13-reconditionne',     label: 'iPhone 13',     fromPrice: 379, inStock: true  },
      { handle: 'iphone-14-reconditionne',     label: 'iPhone 14',     fromPrice: 449, inStock: true  }
    ],
    i12: [
      { handle: 'iphone-13-reconditionne',     label: 'iPhone 13',     fromPrice: 379, inStock: true  },
      { handle: 'iphone-14-reconditionne',     label: 'iPhone 14',     fromPrice: 449, inStock: true  },
      { handle: 'iphone-15-reconditionne',     label: 'iPhone 15',     fromPrice: 579, inStock: true  }
    ],
    i13: [
      { handle: 'iphone-14-reconditionne',     label: 'iPhone 14',     fromPrice: 449, inStock: true  },
      { handle: 'iphone-15-reconditionne',     label: 'iPhone 15',     fromPrice: 579, inStock: true  },
      { handle: 'iphone-16-reconditionne',     label: 'iPhone 16',     fromPrice: 749, inStock: false }
    ],
    i13pro: [
      { handle: 'iphone-14-pro-reconditionne', label: 'iPhone 14 Pro', fromPrice: 629, inStock: true  },
      { handle: 'iphone-15-pro-reconditionne', label: 'iPhone 15 Pro', fromPrice: 819, inStock: true  },
      { handle: 'iphone-16-pro-reconditionne', label: 'iPhone 16 Pro', fromPrice: 1019, inStock: false }
    ],
    i14: [
      { handle: 'iphone-15-reconditionne',     label: 'iPhone 15',     fromPrice: 579, inStock: true  },
      { handle: 'iphone-16-reconditionne',     label: 'iPhone 16',     fromPrice: 749, inStock: true  }
    ],
    i14pro: [
      { handle: 'iphone-15-pro-reconditionne', label: 'iPhone 15 Pro', fromPrice: 819, inStock: true  },
      { handle: 'iphone-16-pro-reconditionne', label: 'iPhone 16 Pro', fromPrice: 1019, inStock: true }
    ],
    i15: [
      { handle: 'iphone-16-reconditionne',     label: 'iPhone 16',     fromPrice: 749, inStock: true  }
    ],
    i15pro: [
      { handle: 'iphone-16-pro-reconditionne', label: 'iPhone 16 Pro', fromPrice: 1019, inStock: true }
    ],
    // ── Variantes Pro Max : on conserve la base « Pro Max » sur les
    // suggestions au lieu de proposer du « Pro » classique.
    i11max: [
      { handle: 'iphone-12-pro-max-reconditionne', label: 'iPhone 12 Pro Max', fromPrice: 449, inStock: true },
      { handle: 'iphone-13-pro-max-reconditionne', label: 'iPhone 13 Pro Max', fromPrice: 599, inStock: true },
      { handle: 'iphone-14-pro-max-reconditionne', label: 'iPhone 14 Pro Max', fromPrice: 749, inStock: true }
    ],
    i12max: [
      { handle: 'iphone-13-pro-max-reconditionne', label: 'iPhone 13 Pro Max', fromPrice: 599, inStock: true },
      { handle: 'iphone-14-pro-max-reconditionne', label: 'iPhone 14 Pro Max', fromPrice: 749, inStock: true },
      { handle: 'iphone-15-pro-max-reconditionne', label: 'iPhone 15 Pro Max', fromPrice: 949, inStock: true }
    ],
    i13max: [
      { handle: 'iphone-14-pro-max-reconditionne', label: 'iPhone 14 Pro Max', fromPrice: 749, inStock: true },
      { handle: 'iphone-15-pro-max-reconditionne', label: 'iPhone 15 Pro Max', fromPrice: 949, inStock: true },
      { handle: 'iphone-16-pro-max-reconditionne', label: 'iPhone 16 Pro Max', fromPrice: 1149, inStock: true }
    ],
    i14max: [
      { handle: 'iphone-15-pro-max-reconditionne', label: 'iPhone 15 Pro Max', fromPrice: 949, inStock: true },
      { handle: 'iphone-16-pro-max-reconditionne', label: 'iPhone 16 Pro Max', fromPrice: 1149, inStock: true }
    ],
    i15max: [
      { handle: 'iphone-16-pro-max-reconditionne', label: 'iPhone 16 Pro Max', fromPrice: 1149, inStock: true }
    ],
    // ── Variantes Plus : on conserve un grand écran.
    i14plus: [
      { handle: 'iphone-15-plus-reconditionne', label: 'iPhone 15 Plus', fromPrice: 679, inStock: true  },
      { handle: 'iphone-16-plus-reconditionne', label: 'iPhone 16 Plus', fromPrice: 849, inStock: true  }
    ],
    i15plus: [
      { handle: 'iphone-16-plus-reconditionne', label: 'iPhone 16 Plus', fromPrice: 849, inStock: true }
    ]
    // i16/i17 : pas d'upgrade pertinent (modèles courants)
  };

  // Déduit la clé UPGRADE depuis le libellé exact du modèle.
  // « iPhone 13 Pro Max » → 'i13max', « iPhone 14 Plus » → 'i14plus',
  // sinon retombe sur la fam standard (i13pro, i14, …).
  function upgradeKey(modelLabel, fam) {
    if (!modelLabel) return fam;
    if (/Pro Max/i.test(modelLabel)) {
      const num = (modelLabel.match(/\b(\d{1,2})\b/) || [])[1];
      if (num) return 'i' + num + 'max';
    }
    if (/Plus/i.test(modelLabel)) {
      const num = (modelLabel.match(/\b(\d{1,2})\b/) || [])[1];
      if (num) return 'i' + num + 'plus';
    }
    return fam;
  }
  // Seuil de déclenchement : réparation ≥ 45 % de la valeur reprise.
  const UPSELL_THRESHOLD = 0.35;

  const ISSUES = [
    { id: 'screen',   label: 'Écran cassé / fissuré',  hint: 'Vitre + dalle, garantis 12 mois.' },
    { id: 'battery',  label: 'Batterie / autonomie',   hint: 'Batterie neuve — mêmes composants qu\'une batterie d\'origine, garantie 12 mois (testée 30 min).' },
    { id: 'charging', label: 'Connecteur de charge',   hint: 'Port Lightning ou USB-C.' },
    { id: 'back',     label: 'Vitre arrière cassée',   hint: 'Verre arrière, posé sous presse. Si la casse est importante, on recommande un changement de châssis (+50 à 70€).' },
    { id: 'camera',       label: 'Caméra arrière', hint: 'Module photo arrière.' },
    { id: 'camera_front', label: 'Caméra avant',   hint: 'Caméra selfie avant.' },
    { id: 'water',    label: 'Dégât des eaux',         hint: 'Diagnostic + traitement, à partir de 60 €.' },
    { id: 'software', label: 'Logiciel / lenteurs',    hint: 'Réinstallation propre + diag.' },
    { id: 'other',    label: 'Autre / je ne sais pas', hint: 'Diagnostic 29 € — ou autre panne.' }
  ];

  // Familles à vitre arrière AMOVIBLE (verre Apple d'origine) : pas
  // d'avertissement ni d'upsell châssis. Les autres ont une vitre collée
  // (re-vitrage moins résistant qu'à l'origine).
  const REMOVABLE_BACK_FAM = ['i14', 'i15', 'i16', 'i17'];

  // Libellés + ordre des qualités d'écran (4 niveaux).
  const SCREEN_QLABELS = {
    eco: 'Éco', recond: 'Reconditionné', premium: 'Premium', origine: 'Origine Apple'
  };
  const SCREEN_QORDER = ['eco', 'recond', 'premium', 'origine'];
  // Qualités INDISPONIBLES par famille (alignement réalité atelier).
  // — iPhone 11 et antérieurs : pas d'écran Éco proposé.
  // — iPhone 12 et postérieurs : pas de Reconditionné (re-vitrage d'origine
  //   pas pratiqué sur ces modèles, dalle neuve ou Apple d'origine directe).
  const SCREEN_QUALITY_BLOCKLIST = {
    se:  ['eco', 'recond'],
    i11: ['recond']
    // iPhone 12 et postérieurs : aucun tier n'est bloqué — Éco, Recond,
    // Premium et Origine Apple sont tous proposés.
  };
  // Exclusions par MODÈLE, et non par famille.
  //
  // ⚠️ Le 13 mini partage sa famille (`i13`) avec l'iPhone 13 : lui retirer
  // Premium par la liste ci-dessus l'aurait retiré au 13 aussi, sur un
  // catalogue où les deux se vendent. Une exclusion qui déborde sur un
  // voisin est un prix qui disparaît sans que personne l'ait demandé.
  const SCREEN_QUALITY_BLOCKLIST_MODEL = {
    'iphone-13-mini': ['premium']
  };
  function isQualityAvailable(fam, q, modelId) {
    if (modelId && (SCREEN_QUALITY_BLOCKLIST_MODEL[modelId] || []).indexOf(q) >= 0) return false;
    return (SCREEN_QUALITY_BLOCKLIST[fam] || []).indexOf(q) < 0;
  }

  // Tableau comparatif des qualités d'écran (affiché via le « i »).
  const SCREEN_QUALITY_ROWS = [
    ['', 'Éco', 'Reconditionné', 'Premium', 'Origine Apple'],
    ['Toucher', 'Bon (90 %)', 'Parfait (99,9 %)', 'Parfait (99,9 %)', 'Parfait (99,9 %)'],
    ['Type d\'écran', 'Compatible bonne qualité', 'Votre écran Apple, re-vitré', 'Haut de gamme', 'Apple neuf d\'origine'],
    ['Luminosité', 'Correcte', 'Comme l\'origine', 'Comme l\'origine', 'Comme l\'origine'],
    ['Garantie', '30 jours', '12 mois', '12 mois', '12 mois'],
    ['Temps à consacrer', '~15 min', '1 h – 2 h', '~15 min', '~15 min']
  ];

  const DAY_LBL = ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'];
  const MONTHS  = ['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];
  const TIMES   = ['10:00','10:30','11:00','11:30','12:00','12:30','13:00','13:30','14:00','14:30','15:00','15:30','16:00','16:30','17:00','17:30','18:00','18:30'];

  function money(v) {
    if (v == null) return '—';
    try { return new Intl.NumberFormat('fr-FR', { style:'currency', currency:'EUR', maximumFractionDigits:0 }).format(v); }
    catch (_) { return Math.round(v) + ' €'; }
  }
  // Mensualité formatée avec 2 décimales pour le 4× sans frais.
  function money2(v) {
    if (v == null) return '—';
    try { return new Intl.NumberFormat('fr-FR', { style:'currency', currency:'EUR', minimumFractionDigits:2, maximumFractionDigits:2 }).format(v); }
    catch (_) { return v.toFixed(2) + ' €'; }
  }
  function fmtDate(d) { return DAY_LBL[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  // Délai minimum avant un créneau (préparation atelier). 30 min : à 17h30
  // on peut encore réserver 18h00 le soir même.
  const SLOT_LEAD_MIN = 30;
  const LAST_SLOT_MIN = 18 * 60 + 30; // 18:30, dernier créneau de la journée.
  function nextDays(n) {
    const out = []; const today = new Date(); today.setHours(0,0,0,0);
    const now = new Date();
    const nowMin = now.getHours() * 60 + now.getMinutes();
    // On inclut AUJOURD'HUI (i=0) sauf si : dimanche, ou s'il est déjà trop
    // tard pour le dernier créneau (now + lead > 18h30). Sinon on démarre
    // demain. Avant ce fix, la boucle commençait à i=1 → aujourd'hui jamais
    // proposé, impossible de réserver le soir même.
    let startI = 0;
    if (now.getDay() === 0 || nowMin + SLOT_LEAD_MIN > LAST_SLOT_MIN) startI = 1;
    for (let i = startI; out.length < n && i < 90; i++) {
      const nd = new Date(today.getTime() + i * 86400000);
      if (nd.getDay() !== 0) out.push(nd); // ferme dimanche
    }
    return out;
  }
  function $(sel, r) { return (r || document).querySelector(sel); }
  function $$(sel, r) { return Array.prototype.slice.call((r || document).querySelectorAll(sel)); }

  function init(root) {
    const endpoint = root.getAttribute('data-endpoint') || '';
    const secret   = root.getAttribute('data-secret') || '';
    const trackUrl = root.getAttribute('data-tracking-url') || '/pages/suivi';
    // Contact de repli affiché au client si la réservation en ligne échoue,
    // + endpoint d'alerte qui prévient l'équipe en temps réel (mail).
    const contactPhone = root.getAttribute('data-contact-phone') || '01 76 43 35 24';
    const contactEmail = root.getAttribute('data-contact-email') || 'salut@iphumat.com';
    const alertEndpoint = root.getAttribute('data-alert-endpoint')
      || 'https://salut-hub-iphumat.odoo.com/iphumat/booking/alert';
    // Connexion AUTO-RÉPARANTE : le token part du réglage thème, mais si celui-ci
    // est vide ou refusé par Odoo, on va chercher un token frais ici et on
    // réessaie. Le tunnel ne dépend donc plus d'un réglage qu'un déploiement
    // pourrait effacer (c'est ce qui avait coupé les réservations 10 jours).
    const tokenEndpoint = root.getAttribute('data-token-endpoint')
      || 'https://salut-hub-iphumat.odoo.com/iphumat/booking/token';
    let runtimeToken = secret || '';
    let tokenFetch = null; // dédup des fetch concurrents
    function fetchFreshToken() {
      if (tokenFetch) return tokenFetch;
      tokenFetch = fetch(tokenEndpoint, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.ok && d.token) { runtimeToken = d.token; } return runtimeToken; })
        .catch(function () { return runtimeToken; })
        .then(function (t) { tokenFetch = null; return t; });
      return tokenFetch;
    }
    // Si le thème n'a pas de secret, on en récupère un tout de suite (la 1re
    // réservation part alors avec un token valide, sans aller-retour d'échec).
    if (!secret) { fetchFreshToken(); }
    // Endpoint estimation reprise (mêmes prix BackMarket que le wizard reprise).
    const estimateEndpoint = root.getAttribute('data-estimate-endpoint')
      || 'https://salut-hub-iphumat.odoo.com/iphumat/reprise/estimate';
    // Endpoint grille de prix réparation EXACTE (Odoo). Renvoie par modèle :
    // { screen:{premium,origine,eco}, battery, back, chassis }.
    const repairPricesEndpoint = root.getAttribute('data-repair-prices-endpoint')
      || 'https://salut-hub-iphumat.odoo.com/iphumat/repair/prices';
    // Cache des prix Odoo par libellé modèle. {} = pas encore chargé.
    const odooPriceCache = {};
    // Teintes d'origine par modèle, servies par le même endpoint Odoo. Le
    // catalogue fait foi : une couleur ajoutée là apparaît ici sans toucher
    // au thème.
    const odooColorCache = {};
    // Qualité d'écran retenue pour le prix de base (Éco par défaut = prix
    // d'appel affiché, le client peut monter vers Premium / Origine Apple).
    let screenQuality = 'eco';
    // Comble le prix « Reconditionné » quand Odoo ne le renvoie pas :
    // il se situe entre Éco et Premium (re-vitrage d'une dalle Apple
    // d'origine), arrondi aux 5 €. Ne s'applique PAS aux familles
    // bloquées (iPhone 12+ : on ne propose plus Recond du tout).
    function fillReconditionne(sc, fam) {
      if (!sc || sc.recond != null) return sc;
      if (fam && !isQualityAvailable(fam, 'recond')) return sc;
      const eco = sc.eco, premium = sc.premium, origine = sc.origine;
      let v = null;
      if (eco != null && premium != null) v = eco + (premium - eco) * 0.7;
      else if (premium != null) v = premium - 20;
      else if (origine != null) v = origine - 40;
      else if (eco != null) v = eco + 30;
      if (v != null) sc.recond = Math.max(20, Math.round(v / 5) * 5);
      return sc;
    }
    function fetchRepairPrices(modelLabel, cb) {
      if (!modelLabel || !repairPricesEndpoint) return cb && cb({});
      if (odooPriceCache[modelLabel]) return cb && cb(odooPriceCache[modelLabel]);
      fetch(repairPricesEndpoint + '?model=' + encodeURIComponent(modelLabel),
        { headers: { Accept: 'application/json' } })
        .then(r => r.json())
        .then(res => {
          const p = (res && res.prices) ? res.prices : {};
          if (p.screen) fillReconditionne(p.screen, state.fam);
          odooPriceCache[modelLabel] = p;
          // Les teintes d'origine du modèle arrivent dans la MÊME réponse.
          // Cache séparé : `odooPriceCache` est interrogé par identifiant de
          // panne (`priceFor('back')`), y glisser une clé « colors » serait
          // une collision qui attend son jour.
          odooColorCache[modelLabel] = (res && res.colors) || [];
          cb && cb(p);
        })
        .catch(() => { odooPriceCache[modelLabel] = {}; cb && cb({}); });
    }
    // Prix d'une panne : priorité grille Odoo (exacte), sinon barème interne.
    function priceFor(id) {
      const op = odooPriceCache[state.modelLabel];
      // Si l'utilisateur a choisi « châssis complet » sous l'option vitre
      // arrière, on remplace le prix « back » par le prix « chassis ».
      const effectiveId = (id === 'back' && state.backChoice === 'chassis') ? 'chassis' : id;
      if (op) {
        if (id === 'screen' && op.screen) {
          return op.screen[screenQuality] != null ? op.screen[screenQuality]
            : (op.screen.origine != null ? op.screen.origine
              : (op.screen.premium != null ? op.screen.premium : op.screen.eco));
        }
        if (op[effectiveId] != null) return op[effectiveId];
      }
      // « Autre / je ne sais pas » : diagnostic forfaitaire 29 €.
      if (id === 'other') return 29;
      const fam = state.fam || 'other';
      const fb = (PRICES[fam] || {})[effectiveId];
      if (fb != null) return fb;
      // Pas de prix châssis dans le fallback interne : on majore le back de 60 €.
      if (effectiveId === 'chassis' && (PRICES[fam] || {}).back != null) {
        return PRICES[fam].back + 60;
      }
      return null;
    }
    // Indique si le prix d'une panne vient de la grille Odoo (donc exact).
    // Note : certaines pannes (eau, face arrière, connecteur de charge) ont
    // un prix franc et non « à partir de » même quand la grille Odoo n'est
    // pas chargée — l'affichage doit être direct, sans « à partir de ».
    const EXACT_ALWAYS = { water: true, back: true, charging: true, chassis: true };
    function isExact(id) {
      const effId = (id === 'back' && state.backChoice === 'chassis') ? 'chassis' : id;
      if (EXACT_ALWAYS[effId]) return true;
      const op = odooPriceCache[state.modelLabel];
      if (!op) return false;
      if (id === 'screen') return !!op.screen;
      return op[effId] != null;
    }
    // Modèles à Face ID (iPhone X et +, hors SE à Touch ID) : le remplacement
    // de la caméra AVANT comporte un risque de perte du Face ID.
    function hasFaceID(label) {
      var s = (label || '').toLowerCase();
      if (s.indexOf('se') >= 0) return false;        // SE = Touch ID
      if (/iphone\s*x/.test(s)) return true;         // X / XR / XS / XS Max
      var m = s.match(/iphone\s*(\d{1,2})/);
      return !!(m && parseInt(m[1], 10) >= 11);      // 11 et +
    }
    // Cache des valeurs reprise BackMarket par libellé modèle (évite refetch).
    const bmValueCache = {};
    function ensureBmValue(modelLabel, cb) {
      if (!modelLabel || !estimateEndpoint) return cb(null);
      if (Object.prototype.hasOwnProperty.call(bmValueCache, modelLabel)) {
        return cb(bmValueCache[modelLabel]);
      }
      fetch(estimateEndpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sector: 'phone', brand: 'Apple', model_name: modelLabel, grade: 'B' })
      })
        .then(r => r.json())
        .then(res => {
          var v = (res && res.found && res.price > 0) ? res.price : null;
          bmValueCache[modelLabel] = v;
          cb(v);
        })
        .catch(() => { bmValueCache[modelLabel] = null; cb(null); });
    }

    const stepsEl    = $('[data-bw-steps]', root);
    const progressEl = $('[data-bw-progress]', root);
    const recap = {
      model:  $('[data-bw-recap-model]', root),
      issue:  $('[data-bw-recap-issue]', root),
      price:  $('[data-bw-recap-price]', root),
      fourx:  $('[data-bw-recap-fourx]', root),
      slot:   $('[data-bw-recap-slot]', root),
      contact:$('[data-bw-recap-contact]', root)
    };

    const state = {
      modelId: '', modelLabel: '', fam: '',
      issueIds: [], issueLabels: [], price: null, priceFull: null, multiDiscount: 0, multiRepair: false,
      dayIdx: -1, time: '', slotIso: '', slotLbl: '',
      first_name: '', last_name: '', email: '', phone: '', company: '', address: '', message: '',
      clientType: 'particulier',
      upsellShown: false,
      backChoice: 'back',
      backColor: '',
      deliveryType: 'in_shop'
    };
    const slotsEndpoint = root.getAttribute('data-slots-endpoint') || '';
    // Réparation à distance : dormante tant que la section ne passe pas
    // data-mailin-enabled="true" (miroir du flag société). Fee configurable.
    const mailinEnabled = root.getAttribute('data-mailin-enabled') === 'true';
    const mailinFee = parseFloat(root.getAttribute('data-mailin-fee') || '15') || 15;
    // Promo « 2 réparations = -20 % » : pilotée par le toggle de la section
    // (data-multi-discount-pct = 0 quand le bandeau est désactivé, sinon 20).
    // On convertit en coefficient ; promoLabel sert d'étiquette d'affichage.
    const multiDiscountPct = parseFloat(root.getAttribute('data-multi-discount-pct') || '20');
    const multiRate = (isFinite(multiDiscountPct) && multiDiscountPct > 0) ? multiDiscountPct / 100 : 0;
    const promoLabel = '-' + Math.round(multiRate * 100) + ' %';
    let busySlots = []; // [{start:'YYYY-MM-DDTHH:MM', stop:'…'}]
    let stepIdx = 0;

    // Build steps ─────────────────────────────────────────────────────
    const s1 = stepEl('1. Quel modèle ?', 'Choisissez votre iPhone.', renderModels());
    const s2 = stepEl('2. Quelle(s) panne(s) ?', 'Cochez tout ce qui pose souci — le devis se met à jour.',
      '<div data-issue-grid></div>' +
      '<div class="bw-issues__foot" data-issues-foot hidden>' +
        '<p class="bw-issues__total">Total indicatif : <b data-issues-total>—</b><span class="bw-issues__fourx" data-issues-fourx></span><small data-issues-detail></small></p>' +
        '<button type="button" class="btn btn--accent" data-issues-next>Choisir un créneau →</button>' +
      '</div>');
    const s3 = stepEl('3. Quel créneau ?', 'Atelier ouvert du lundi au samedi — ou réparation à distance.',
      '<div class="bw-segment" data-bw-delivery role="radiogroup" aria-label="Mode de dépôt" hidden style="margin-bottom:14px">' +
        '<button type="button" class="bw-segment__btn is-active" data-bw-delivery-opt="in_shop" aria-pressed="true">Je dépose à l\'atelier</button>' +
        '<button type="button" class="bw-segment__btn" data-bw-delivery-opt="mail_in" aria-pressed="false">Réparation à distance</button>' +
      '</div>' +
      '<div class="slots" data-bw-slots-panel><p class="slots__legend">Jour</p><div class="slots__days" data-bw-days></div>' +
      '<p class="slots__legend" style="margin-top:10px">Heure</p><div class="slots__times" data-bw-times></div>' +
      '<p class="slots__chosen" data-bw-chosen aria-live="polite"></p></div>' +
      '<div class="bw-mailin" data-bw-mailin-panel hidden>' +
        '<p style="padding:14px 18px;background:#f7f2e9;border-radius:10px;font-size:14px;color:#2a2118">' +
        '📦 On vous envoie une <b>étiquette prépayée</b> (point relais Chronopost). Vous nous expédiez votre appareil, on le répare et on vous le renvoie — <b data-bw-mailin-fee></b>.</p>' +
        '<button type="button" class="btn btn--accent" data-bw-mailin-continue>Continuer →</button>' +
      '</div>');
    const s4 = stepEl('4. Vos coordonnées', 'Pour vous envoyer la confirmation et le suivi.',
      '<form class="bw-contact" data-bw-form>' +
        '<div class="bw-segment" data-client-type role="radiogroup" aria-label="Type de client">' +
          '<button type="button" class="bw-segment__btn is-active" data-ctype="particulier" aria-pressed="true">Particulier</button>' +
          '<button type="button" class="bw-segment__btn" data-ctype="pro" aria-pressed="false">Professionnel</button>' +
        '</div>' +
        '<div class="field-row">' +
          '<div class="field"><label for="bw-fname">Prénom *</label><input id="bw-fname" name="first_name" type="text" autocomplete="given-name" required></div>' +
          '<div class="field"><label for="bw-lname">Nom *</label><input id="bw-lname" name="last_name" type="text" autocomplete="family-name" required></div>' +
        '</div>' +
        '<div class="field-row">' +
          '<div class="field"><label for="bw-email">Email *</label><input id="bw-email" name="email" type="email" autocomplete="email" required></div>' +
          '<div class="field"><label for="bw-phone">Téléphone *</label><input id="bw-phone" name="phone" type="tel" autocomplete="tel" inputmode="numeric" pattern="0[0-9]{9}" maxlength="10" placeholder="0612345678" required></div>' +
        '</div>' +
        '<div class="bw-pro-fields" data-pro-fields hidden>' +
          '<div class="field"><label for="bw-company">Société *</label><input id="bw-company" name="company" type="text" autocomplete="organization"></div>' +
          '<div class="field"><label for="bw-address">Adresse de facturation</label><input id="bw-address" name="address" type="text" autocomplete="street-address" placeholder="N° rue, code postal, ville"></div>' +
        '</div>' +
        '<div class="field"><label for="bw-msg">Précisions (facultatif)</label><textarea id="bw-msg" name="message" rows="3" placeholder="Ex. mon écran a 2 fissures, le tactile fonctionne…"></textarea></div>' +
        '<div class="hp" aria-hidden="true"><label>Ne pas remplir<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
        '<button type="submit" class="btn btn--accent btn--lg btn--block">Valider ma réservation</button>' +
        '<p class="booking__status" data-bw-status role="status" aria-live="polite"></p>' +
      '</form>');
    const s5 = stepEl('Réservation confirmée', '', '<div data-bw-success></div>');

    stepsEl.appendChild(s1); stepsEl.appendChild(s2); stepsEl.appendChild(s3); stepsEl.appendChild(s4); stepsEl.appendChild(s5);

    // Step 1: model selection
    stepsEl.addEventListener('click', function (e) {
      const m = e.target.closest('[data-pick-model]'); if (!m) return;
      state.modelId = m.getAttribute('data-pick-model');
      const meta = MODELS.find(x => x.id === state.modelId);
      state.modelLabel = meta.label; state.fam = meta.fam;
      $$('[data-pick-model]', stepsEl).forEach(b => b.classList.toggle('is-active', b === m));
      // Reset downstream pricing
      state.issueIds = []; state.issueLabels = []; state.price = null;
      // La teinte appartient au modèle précédent : la garder ferait
      // commander une pièce d'un iPhone pour un autre.
      state.backColor = '';
      buildIssues();
      updateRecap();
      goTo(1);
      // Récupère la grille Odoo exacte pour ce modèle puis ré-affiche les prix.
      fetchRepairPrices(state.modelLabel, function () {
        buildIssues();
        recomputeTotal();
      });
    });

    // Step 2: multi-select issues with running total.
    function buildIssues() {
      const grid = $('[data-issue-grid]', s2);
      const fam = state.fam || 'other';
      grid.innerHTML = '<div class="bw-issues">' + ISSUES.map(i => {
        const p = priceFor(i.id);
        // « Autre » : diagnostic forfaitaire. Sinon prix exact Odoo ou « à partir de ».
        let priceLbl;
        if (i.id === 'other') priceLbl = 'Diagnostic ' + money(29);
        else priceLbl = p != null
          ? (isExact(i.id) ? money(p) : 'à partir de ' + money(p))
          : '—';
        // Sélecteur de qualité d'écran (Premium / Origine / Éco), affiché
        // sous la panne « écran » quand elle est cochée.
        const qualHtml = i.id === 'screen'
          ? '<span class="bw-qual" data-screen-qual hidden></span>' : '';
        // Warning châssis pour la vitre arrière : UNIQUEMENT sur les modèles
        // à vitre collée (re-vitrage fragile). Les familles à vitre amovible
        // (verre Apple d'origine) ne reçoivent ni avertissement ni upsell.
        const backGlued = REMOVABLE_BACK_FAM.indexOf(fam) < 0;
        const backPickerHtml = (i.id === 'back' && backGlued)
          ? '<span class="bw-back-pick" data-back-pick hidden></span>' : '';
        // Couleur d'origine : demandée dès que la vitre arrière est cochée,
        // sur TOUS les modèles — le choix vitre seule / châssis ne concerne
        // que les vitres collées, la teinte, elle, est toujours nécessaire
        // pour commander et poser la bonne pièce.
        const backColorHtml = (i.id === 'back')
          ? '<span class="bw-back-color" data-back-color-host hidden></span>' : '';
        // Caméra avant sur modèle Face ID : avertissement fort (risque Face ID).
        let hint = i.hint;
        if (i.id === 'camera_front' && hasFaceID(state.modelLabel)) {
          hint = '<b style="color:#9a2c2f">⚠️ ATTENTION Face ID :</b> sur ce modèle, '
            + 'remplacer la caméra avant peut <b>désactiver définitivement le Face ID</b> '
            + 'si l\'opération échoue. La caméra selfie, elle, refonctionnera à 100 %. '
            + 'On vous prévient toujours avant d\'intervenir.';
        }
        return '<label class="bw-issue" data-issue-row="' + i.id + '">' +
          '<input type="checkbox" data-pick-issue="' + i.id + '" hidden>' +
          '<span class="bw-issue__check" aria-hidden="true"></span>' +
          '<span class="bw-issue__body">' +
            '<span class="bw-issue__top">' +
              '<span class="bw-issue__label">' + i.label + '</span>' +
              '<span class="bw-issue__price">' + priceLbl + '</span>' +
            '</span>' +
            '<span class="bw-issue__hint">' + hint + '</span>' +
            qualHtml +
            backPickerHtml +
            backColorHtml +
          '</span>' +
        '</label>';
      }).join('') + '</div>';
      // Restaure les pannes déjà cochées en state (cas du fam re-sélectionné
      // ou des prices Odoo arrivés en retard).
      state.issueIds.forEach(id => {
        const cb = $('[data-pick-issue="' + id + '"]', s2);
        if (cb) {
          cb.checked = true;
          const row = cb.closest('[data-issue-row]');
          if (row) row.classList.add('is-active');
        }
      });
      renderScreenQual();
      renderBackPick();
      renderBackColor();
    }

    // Construit / met à jour le sélecteur de qualité d'écran sous la panne
    // « écran ». Affiché seulement si l'écran est coché ET qu'Odoo fournit
    // plusieurs qualités (premium / origine / eco).
    function renderScreenQual() {
      const host = $('[data-screen-qual]', s2);
      if (!host) return;
      const checked = state.issueIds.indexOf('screen') >= 0;
      const fam = state.fam || 'other';
      const op = odooPriceCache[state.modelLabel];
      const sc = op && op.screen;
      const avail = sc
        ? SCREEN_QORDER.filter(q => sc[q] != null && isQualityAvailable(fam, q, state.modelId))
        : [];
      if (!checked || avail.length < 2) { host.hidden = true; host.innerHTML = ''; return; }
      // Si la qualité courante n'est pas dispo pour ce modèle, on retombe sur
      // la 1ère disponible (évite un sélecteur sans bouton actif).
      if (avail.indexOf(screenQuality) < 0) screenQuality = avail[0];
      host.hidden = false;
      host.setAttribute('style', 'display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-top:10px');
      // Garantie selon qualité : éco = 30 j, autres = 12 mois.
      const WARRANTY = { eco: '30 j', recond: '12 mois', premium: '12 mois', origine: '12 mois' };
      host.innerHTML =
        '<span style="font-size:12px;color:#8a7d6b;width:100%;margin-bottom:2px">Qualité d\'écran :</span>' +
        avail.map(q => {
          const active = (q === screenQuality);
          const bg = active ? '#9a5b34' : '#fff';
          const color = active ? '#fff' : '#2a2118';
          const border = active ? '#9a5b34' : '#e6ddd0';
          const shadow = active ? '0 2px 8px rgba(154,91,52,.25)' : 'none';
          return '<button type="button" data-qual="' + q + '"' +
            ' style="padding:8px 14px 6px;border:1.5px solid ' + border +
            ';background:' + bg + ';color:' + color +
            ';border-radius:14px;font:inherit;font-size:13px;cursor:pointer;' +
            'transition:all .15s ease;box-shadow:' + shadow +
            ';display:inline-flex;flex-direction:column;align-items:center;line-height:1.25;min-width:84px">' +
              '<span style="font-weight:600">' + SCREEN_QLABELS[q] + '</span>' +
              '<span style="font-size:12px;margin-top:2px">' + money(sc[q]) + '</span>' +
              '<span style="font-size:10px;opacity:.8;margin-top:1px">Garantie ' + WARRANTY[q] + '</span>' +
            '</button>';
        }).join('') +
        // Bouton « i » : ouvre le tableau comparatif des qualités.
        '<button type="button" data-screen-info aria-label="Comparer les qualités" ' +
        'title="Comparer les qualités d\'écran" style="margin-left:2px;width:28px;height:28px;' +
        'border-radius:999px;border:1px solid #e6ddd0;background:#fff;cursor:pointer;' +
        'font-size:14px;line-height:1;color:#8a7d6b">ⓘ</button>';
      // Le panneau comparatif n'est PLUS rendu inline (provoquait un scroll
      // interminable sur mobile). Il s'ouvre maintenant en MODAL au clic du ⓘ
      // — cf. handler plus bas.
    }

    // (Le tableau comparatif est rendu dans un MODAL au clic du ⓘ, plus dans
    // le flow inline qui cassait la hauteur mobile. Cf. showScreenQualityModal.)

    // Picker « vitre arrière seule » vs « châssis complet ». Affiché sous
    // l'option « Vitre arrière cassée » uniquement sur les modèles à vitre
    // COLLÉE (i13 et antérieurs). Permet au client de choisir directement
    // sans qu'un agent doive rappeler.
    function renderBackPick() {
      const host = $('[data-back-pick]', s2);
      if (!host) return;
      const checked = state.issueIds.indexOf('back') >= 0;
      if (!checked) { host.hidden = true; host.innerHTML = ''; return; }
      const op = odooPriceCache[state.modelLabel] || {};
      const fam = state.fam || 'other';
      const fallback = (PRICES[fam] || {});
      const backP    = (op.back    != null) ? op.back    : fallback.back;
      const chassisP = (op.chassis != null) ? op.chassis : (backP != null ? backP + 60 : null);
      if (backP == null && chassisP == null) { host.hidden = true; host.innerHTML = ''; return; }
      host.hidden = false;
      host.setAttribute('style', 'display:flex;flex-wrap:wrap;gap:8px;align-items:flex-start;margin-top:10px');
      const opts = [
        { key: 'back',    lbl: 'Vitre seule',     sub: 'Re-vitrage sous presse', price: backP },
        { key: 'chassis', lbl: 'Châssis complet', sub: 'Châssis d\'origine, bien plus solide et durable. Conseillé si la vitre est très abîmée', price: chassisP }
      ];
      host.innerHTML =
        '<span style="font-size:12px;color:#8a7d6b;width:100%;margin-bottom:2px">Type de réparation :</span>' +
        opts.map(o => {
          const active = (o.key === state.backChoice);
          const bg = active ? '#9a5b34' : '#fff';
          const color = active ? '#fff' : '#2a2118';
          const border = active ? '#9a5b34' : '#e6ddd0';
          const shadow = active ? '0 2px 8px rgba(154,91,52,.25)' : 'none';
          const sub = active ? 'rgba(255,255,255,.85)' : '#8a7d6b';
          return '<button type="button" data-back-opt="' + o.key + '"' +
            ' style="flex:1 1 140px;padding:10px 12px;border:1.5px solid ' + border +
            ';background:' + bg + ';color:' + color +
            ';border-radius:14px;font:inherit;font-size:13px;cursor:pointer;' +
            'transition:all .15s ease;box-shadow:' + shadow +
            ';display:flex;flex-direction:column;align-items:flex-start;line-height:1.3;text-align:left">' +
              '<span style="font-weight:600">' + o.lbl + (o.price != null ? ' — ' + money(o.price) : '') + '</span>' +
              '<span style="font-size:11.5px;margin-top:2px;color:' + sub + '">' + o.sub + '</span>' +
            '</button>';
        }).join('');
    }

    // Couleur d'origine de l'appareil, demandée quand la vitre arrière (ou
    // le châssis) est cochée.
    //
    // Sans elle, l'atelier reçoit un bon qui dit « vitre arrière iPhone 12 »
    // et doit rappeler le client pour savoir laquelle commander — les
    // références portent la teinte (« IPH-CHAS-12-BLEU-A »). Odoo sait déjà
    // s'en servir : `booking_back_color` choisit la bonne pièce à la
    // consommation. Il ne manquait que la question.
    //
    // La liste vient du CATALOGUE (variantes du modèle reconditionné), pas
    // d'une table figée dans le thème : un coloris ajouté dans Odoo apparaît
    // ici tout seul. Si Odoo ne sait pas, on n'affiche rien plutôt qu'une
    // liste fausse — l'atelier tranchera, comme avant.
    function renderBackColor() {
      const host = $('[data-back-color-host]', s2);
      if (!host) return;
      const checked = state.issueIds.indexOf('back') >= 0;
      const teintes = odooColorCache[state.modelLabel] || [];
      if (!checked || !teintes.length) {
        host.hidden = true; host.innerHTML = ''; return;
      }
      host.hidden = false;
      host.setAttribute('style',
        'display:flex;flex-wrap:wrap;gap:6px;align-items:center;margin-top:10px');
      // « Je ne sais pas » est une réponse LÉGITIME : le client n'a pas
      // toujours le nom Apple de sa teinte en tête, et le forcer à deviner
      // produirait une commande de pièce fausse. Odoo ignore cette valeur.
      const choix = teintes.concat(['Je ne sais pas']);
      host.innerHTML =
        '<span style="font-size:12px;color:#8a7d6b;width:100%;margin-bottom:2px">'
        + 'Couleur d\'origine de votre appareil :</span>'
        + choix.map(function (c) {
            const active = (c === state.backColor);
            return '<button type="button" data-back-color="' + esc(c) + '"'
              + ' style="padding:7px 12px;border:1.5px solid '
              + (active ? '#9a5b34' : '#e6ddd0')
              + ';background:' + (active ? '#9a5b34' : '#fff')
              + ';color:' + (active ? '#fff' : '#2a2118')
              + ';border-radius:999px;font:inherit;font-size:12.5px;'
              + 'cursor:pointer;transition:all .15s ease">'
              + esc(c) + '</button>';
          }).join('');
    }

    // Toggle issue (checkbox)
    s2.addEventListener('change', function (e) {
      const cb = e.target.closest('[data-pick-issue]'); if (!cb) return;
      const id = cb.getAttribute('data-pick-issue');
      const row = cb.closest('[data-issue-row]');
      const meta = ISSUES.find(x => x.id === id);
      const i = state.issueIds.indexOf(id);
      if (cb.checked && i < 0) { state.issueIds.push(id); state.issueLabels.push(meta.label); }
      else if (!cb.checked && i >= 0) { state.issueIds.splice(i, 1); state.issueLabels.splice(i, 1); }
      if (row) row.classList.toggle('is-active', cb.checked);
      if (id === 'screen') renderScreenQual();
      if (id === 'back') { renderBackPick(); renderBackColor(); }
      recomputeTotal();
      updateRecap();
      // Upsell : on vérifie discrètement à chaque clic de panne. Si seuil
      // atteint → BANDEAU 1 ligne sous le total (cliquable → ouvre modal).
      // Pas envahissant, mais visible sans devoir cliquer « Valider ».
      ensureBmValue(state.modelLabel, function () {
        const up = computeUpsell();
        if (up && !state.upsellDismissed) renderUpsellTeaser(up);
        else removeUpsellTeaser();
      });
    });
    // Bouton « i » : ouvre/ferme le tableau comparatif des qualités d'écran.
    s2.addEventListener('click', function (e) {
      const ib = e.target.closest('[data-screen-info]');
      if (ib) {
        e.preventDefault(); e.stopPropagation();
        showScreenQualityModal();
        return;
      }
      const bc = e.target.closest('[data-back-color]');
      if (bc) {
        e.preventDefault();
        const val = bc.getAttribute('data-back-color') || '';
        // Re-cliquer la pastille active l'annule : le client qui s'est
        // trompé doit pouvoir revenir en arrière sans recharger la page.
        state.backColor = (state.backColor === val) ? '' : val;
        renderBackColor();
        updateRecap();
        return;
      }
      const bo = e.target.closest('[data-back-opt]');
      if (bo) {
        e.preventDefault();
        state.backChoice = bo.getAttribute('data-back-opt');
        // Met à jour le libellé dans le récap (Vitre arrière → Châssis complet).
        const idx = state.issueIds.indexOf('back');
        if (idx >= 0) {
          state.issueLabels[idx] = state.backChoice === 'chassis'
            ? 'Châssis complet (vitre arrière)'
            : 'Vitre arrière cassée';
        }
        renderBackPick();
        recomputeTotal();
        updateRecap();
      }
    });

    // Lignes <tr> du tableau comparatif des qualités d'écran. `highlightCol`
    // (0-based, optionnel) surligne une colonne — utilisé pour mettre en
    // avant « Reconditionné » dans la pop-up de confirmation.
    function qualityTableRowsHtml(highlightCol) {
      const cell = (txt, head, hl) => '<' + (head ? 'th' : 'td') +
        ' style="border:1px solid #e6ddd0;padding:6px 8px;text-align:left;' +
        'font-weight:' + (head ? '600' : '400') + ';font-size:12.5px' +
        (hl ? ';background:#f3e7db' : '') + '">' +
        txt + '</' + (head ? 'th' : 'td') + '>';
      return SCREEN_QUALITY_ROWS.map((r, ri) =>
        '<tr>' + r.map((c, ci) =>
          cell(c, ri === 0 || ci === 0, highlightCol != null && ci === highlightCol)
        ).join('') + '</tr>').join('');
    }

    // Modal comparatif qualités d'écran — apparaît au clic du ⓘ, fermable
    // par bouton, clic backdrop ou ESC. Évite le scroll interminable du
    // tableau inline sur mobile.
    function showScreenQualityModal() {
      if (document.querySelector('[data-bw-quality-modal]')) return;
      const rows = qualityTableRowsHtml();
      const back = document.createElement('div');
      back.setAttribute('data-bw-quality-modal', '');
      back.setAttribute('role', 'dialog');
      back.setAttribute('aria-modal', 'true');
      back.style.cssText = 'position:fixed;inset:0;background:rgba(42,33,24,.55);' +
        'z-index:9999;display:flex;align-items:center;justify-content:center;' +
        'padding:16px;animation:bwFadeIn .15s ease;overflow:auto';
      back.innerHTML =
        '<div style="background:#fff;border-radius:18px;max-width:640px;width:100%;' +
            'max-height:88vh;overflow:auto;padding:22px 24px;' +
            'box-shadow:0 20px 60px rgba(0,0,0,.3);font-family:Helvetica,Arial,sans-serif;color:#2a2118">' +
          '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:14px">' +
            '<h3 style="margin:0;font-family:Georgia,serif;font-size:18px">Comparatif des qualités d\'écran</h3>' +
            '<button type="button" data-bw-quality-close style="background:transparent;border:0;' +
              'cursor:pointer;font-size:24px;color:#8a7d6b;line-height:1;padding:0 4px;margin:-4px">×</button>' +
          '</div>' +
          '<div style="overflow-x:auto"><table style="border-collapse:collapse;width:100%;min-width:520px;background:#fff">' +
            rows +
          '</table></div>' +
          '<p style="margin:14px 0 0;padding:10px 12px;background:#fff7e6;border:1px solid #f0c98a;' +
              'border-radius:8px;line-height:1.5;color:#7a5a16;font-size:13px">' +
            '<b>Reconditionné</b> : possible uniquement sur un écran d\'origine Apple ' +
            'en parfait état (sans tache, sans trait, sans souci au toucher). L\'opération comporte ' +
            'un risque : l\'écran peut ne pas survivre. Si c\'est le cas, le passage vers une autre ' +
            'qualité reste à votre charge. Le délai « 1 h – 2 h » correspond au temps de ' +
            'séchage avant de récupérer le téléphone, pas à une attente sur place.</p>' +
          '<p style="margin:8px 0 0;font-size:13px;color:#6a6152">' +
            '<b>Éco</b> : toucher fiable (90 % contre 99,9 % sur les autres qualités), ' +
            'garantie 30 jours. Premium et Origine Apple offrent la même luminosité ' +
            'et les mêmes couleurs que l\'écran d\'origine.</p>' +
        '</div>';
      document.body.appendChild(back);
      function close() {
        document.removeEventListener('keydown', onKey);
        if (back.parentNode) back.parentNode.removeChild(back);
      }
      function onKey(ev) { if (ev.key === 'Escape') close(); }
      document.addEventListener('keydown', onKey);
      back.addEventListener('click', function (ev) {
        if (ev.target === back) close();
      });
      back.querySelector('[data-bw-quality-close]').addEventListener('click', close);
    }

    // Qualités d'écran réellement disponibles pour le modèle courant (mêmes
    // règles que renderScreenQual : prix Odoo présent + non bloquée).
    function availableQualities() {
      const fam = state.fam || 'other';
      const op = odooPriceCache[state.modelLabel];
      const sc = op && op.screen;
      return sc
        ? SCREEN_QORDER.filter(q => sc[q] != null && isQualityAvailable(fam, q, state.modelId))
        : [];
    }

    // Applique une qualité d'écran : maj de l'état, re-render du sélecteur,
    // du prix de la ligne « écran », du total et du récap.
    function applyScreenQuality(q) {
      screenQuality = q;
      // Re-render complet du sélecteur pour appliquer le style inline du
      // bouton actif (la classe is-active seule ne suffit pas vu le style
      // inline posé à la création).
      renderScreenQual();
      const cell = $('[data-issue-row="screen"] .bw-issue__price', s2);
      if (cell) {
        const sp = priceFor('screen');
        cell.textContent = sp != null
          ? (isExact('screen') ? money(sp) : 'à partir de ' + money(sp)) : '—';
      }
      recomputeTotal();
      updateRecap();
    }

    // Repli quand le client refuse les conditions du Reconditionné : on garde
    // sa qualité précédente si elle reste valide, sinon Premium (équivalent
    // 99,9 % / 12 mois sans exiger sa dalle d'origine), sinon la 1ère dispo.
    function reconditionneFallback(prev) {
      const avail = availableQualities().filter(q => q !== 'recond');
      if (prev && prev !== 'recond' && avail.indexOf(prev) >= 0) return prev;
      if (avail.indexOf('premium') >= 0) return 'premium';
      return avail[0] || prev || 'eco';
    }

    // Pop-up de confirmation « Reconditionné ». Met en avant le tableau
    // comparatif (colonne Reconditionné surlignée) + les conditions d'accès,
    // puis demande Oui/Non. cb(true) si le client confirme, cb(false) sinon
    // (clic « Non », backdrop ou ESC) → on bascule sur une autre qualité.
    function showReconditionneConfirm(cb) {
      if (document.querySelector('[data-bw-recond-modal]')) return;
      let done = false;
      function finish(ok) {
        if (done) return; done = true;
        document.removeEventListener('keydown', onKey);
        if (back.parentNode) back.parentNode.removeChild(back);
        cb && cb(ok);
      }
      const back = document.createElement('div');
      back.setAttribute('data-bw-recond-modal', '');
      back.setAttribute('role', 'dialog');
      back.setAttribute('aria-modal', 'true');
      back.style.cssText = 'position:fixed;inset:0;background:rgba(42,33,24,.55);' +
        'z-index:10000;display:flex;align-items:center;justify-content:center;' +
        'padding:16px;animation:bwFadeIn .15s ease;overflow:auto';
      back.innerHTML =
        '<div style="background:#fff;border-radius:18px;max-width:640px;width:100%;' +
            'max-height:88vh;overflow:auto;padding:22px 24px;' +
            'box-shadow:0 20px 60px rgba(0,0,0,.3);font-family:Helvetica,Arial,sans-serif;color:#2a2118">' +
          '<h3 style="margin:0 0 10px;font-family:Georgia,serif;font-size:18px">' +
            'Écran reconditionné</h3>' +
          '<p style="margin:0 0 6px;font-size:13.5px;color:#6a6152">' +
            'Possible seulement si votre écran actuel est :</p>' +
          '<ul style="margin:0 0 12px;padding-left:18px;font-size:13.5px;line-height:1.55">' +
            '<li><b>d\'origine Apple</b></li>' +
            '<li><b>en parfait état</b> (sans tache ni trait)</li>' +
            '<li><b>tactile sans bug</b></li>' +
          '</ul>' +
          '<div style="overflow-x:auto;margin-bottom:12px"><table style="border-collapse:collapse;' +
              'width:100%;min-width:520px;background:#fff">' +
            qualityTableRowsHtml(2) +
          '</table></div>' +
          '<p style="margin:0 0 14px;font-size:12.5px;color:#7a5a16">' +
            '⚠️ Le re-vitrage comporte un risque (l\'écran peut ne pas survivre).</p>' +
          '<p style="margin:0 0 10px;font-size:14px;font-weight:600;text-align:center">' +
            'Votre écran remplit ces conditions ?</p>' +
          '<div style="display:flex;gap:10px;justify-content:center">' +
            '<button type="button" data-bw-recond-yes style="flex:1 1 140px;padding:12px 16px;border:0;' +
              'border-radius:14px;background:#9a5b34;color:#fff;font:inherit;font-size:14px;font-weight:600;' +
              'cursor:pointer;box-shadow:0 2px 8px rgba(154,91,52,.25)">Oui</button>' +
            '<button type="button" data-bw-recond-no style="flex:1 1 140px;padding:12px 16px;' +
              'border:1.5px solid #e6ddd0;border-radius:14px;background:#fff;color:#2a2118;font:inherit;' +
              'font-size:14px;cursor:pointer">Non / pas sûr</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(back);
      function onKey(ev) { if (ev.key === 'Escape') finish(false); }
      document.addEventListener('keydown', onKey);
      back.addEventListener('click', function (ev) { if (ev.target === back) finish(false); });
      back.querySelector('[data-bw-recond-yes]').addEventListener('click', function () { finish(true); });
      back.querySelector('[data-bw-recond-no]').addEventListener('click', function () { finish(false); });
    }

    // Choix de la qualité d'écran (Éco / Reconditionné / Premium / Origine).
    s2.addEventListener('click', function (e) {
      const qb = e.target.closest('[data-qual]');
      if (!qb) return;
      // Empêche le label de décocher la panne « écran ».
      e.preventDefault(); e.stopPropagation();
      const q = qb.getAttribute('data-qual');
      // Garde-fou « Reconditionné » : il exige un écran d'origine Apple en
      // parfait état. On demande confirmation explicite (Oui/Non) avant de
      // basculer dessus ; un « Non » retombe sur une autre qualité.
      if (q === 'recond' && screenQuality !== 'recond') {
        const prev = screenQuality;
        showReconditionneConfirm(function (ok) {
          applyScreenQuality(ok ? 'recond' : reconditionneFallback(prev));
        });
        return;
      }
      applyScreenQuality(q);
    });
    // Avancer vers step 3 — l'upsell a déjà été proposé via le teaser
    // sous le total. Au clic « Valider », on passe directement au créneau
    // sauf si l'user n'a pas du tout vu/touché le teaser (cas où le seuil
    // a été atteint mais qu'il a cliqué très vite). Dans ce cas on lui
    // montre une dernière fois le pop-up, sinon il n'aurait jamais vu
    // qu'on avait une option d'upgrade.
    s2.addEventListener('click', function (e) {
      if (!e.target.matches('[data-issues-next]')) return;
      if (!state.issueIds.length) return;
      const hasTeaser = $('[data-bw-upsell-teaser]', s2);
      if (hasTeaser && !state.upsellDismissed && !state.upsellSeen) {
        // L'utilisateur ne s'est pas encore arrêté sur l'upsell → on le
        // bloque une fois (pop-up), il pourra ensuite valider.
        state.upsellSeen = true;
        ensureBmValue(state.modelLabel, function () {
          const upsell = computeUpsell();
          if (upsell) showUpsellModal(upsell);
          else { buildSlots(); goTo(2); }
        });
        return;
      }
      buildSlots(); goTo(2);
    });

    // ── Teaser discret : bandeau 1 ligne sous le total ──────────────── #
    // Apparaît DÈS QUE le seuil est atteint (sans devoir cliquer « Valider »).
    // Cliquable → ouvre le pop-up modal détaillé.
    function renderUpsellTeaser(u) {
      removeUpsellTeaser();
      const foot = $('[data-issues-foot]', s2);
      if (!foot) return;
      const teaser = document.createElement('div');
      teaser.setAttribute('data-bw-upsell-teaser', '');
      teaser.setAttribute('role', 'button');
      teaser.setAttribute('tabindex', '0');
      teaser.style.cssText = (
        'display:flex;align-items:center;gap:10px;margin:10px 0 0;' +
        'padding:11px 14px;border:1.5px dashed #9a5b34;border-radius:12px;' +
        'background:#fff7ec;cursor:pointer;font-size:13px;line-height:1.35;' +
        'transition:background .15s ease');
      teaser.onmouseover = function () { teaser.style.background = '#fce9cf'; };
      teaser.onmouseout = function () { teaser.style.background = '#fff7ec'; };
      const best = u.upgrades[0];
      teaser.innerHTML =
        '<span style="font-size:18px;line-height:1">💡</span>' +
        '<span style="flex:1">' +
          '<b>Et si vous changiez ?</b> Votre ' + esc(state.modelLabel) +
          ' vaut ~' + money(u.tradeIn) + ' en reprise. Pour ' +
          money(best.netAfterTradeIn) + ' (au lieu de ' +
          money(u.repairPrice) + ' de réparation), on a un <b>' +
          esc(best.label) + '</b> en stock.' +
        '</span>' +
        '<span style="flex-shrink:0;padding:6px 12px;background:#9a5b34;' +
            'color:#fff;border-radius:999px;font-weight:600;font-size:12px">' +
            'Voir →</span>' +
        '<button type="button" data-bw-upsell-dismiss aria-label="Masquer la suggestion"' +
          ' style="flex-shrink:0;width:22px;height:22px;border-radius:999px;' +
          'border:0;background:transparent;color:#8a7d6b;cursor:pointer;' +
          'font-size:16px;line-height:1;padding:0">×</button>';
      foot.parentNode.insertBefore(teaser, foot);
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-bw-upsell-dismiss]')) {
          // Croix → dismiss permanent pour ce funnel
          state.upsellDismissed = true;
          removeUpsellTeaser();
          e.stopPropagation();
          return;
        }
        // Clic sur le bandeau → ouvre le modal détaillé
        showUpsellModal(u);
      });
      teaser.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          showUpsellModal(u);
        }
      });
    }
    function removeUpsellTeaser() {
      const t = $('[data-bw-upsell-teaser]', s2);
      if (t && t.parentNode) t.parentNode.removeChild(t);
    }

    // ── Pop-up upgrade modal (affiché au clic sur le teaser, ou en
    // dernier recours au clic « Valider » si jamais l'user n'a pas vu) ─ #
    function showUpsellModal(u) {
      // Si un modal upsell est déjà ouvert (re-clic rapide), no-op.
      if (document.querySelector('[data-bw-upsell-modal]')) return;
      // L'user a vu le détail = pas la peine de redéclencher au Valider.
      state.upsellSeen = true;
      const back = document.createElement('div');
      back.setAttribute('data-bw-upsell-modal', '');
      back.setAttribute('role', 'dialog');
      back.setAttribute('aria-modal', 'true');
      back.style.cssText = (
        'position:fixed;inset:0;background:rgba(42,33,24,.55);z-index:9998;' +
        'display:flex;align-items:center;justify-content:center;padding:16px;' +
        'animation:bwFadeIn .15s ease');
      const upgradeCards = u.upgrades.map((up, i) =>
        '<div data-modal-upsell-card="' + cssEsc(up.handle) + '" style="flex:1;min-width:220px;padding:14px;border-radius:12px;' +
            'background:' + (i === 0 ? '#fff7ec' : '#fff') + ';' +
            'border:1.5px solid ' + (i === 0 ? '#9a5b34' : '#e6ddd0') + '">' +
          (i === 0 ? '<span style="display:inline-block;padding:2px 8px;background:#9a5b34;color:#fff;font-size:10px;border-radius:999px;letter-spacing:.5px;text-transform:uppercase">Recommandé</span>' : '') +
          '<p style="margin:8px 0 4px;font-weight:600;font-size:14px">' + esc(up.label) + '</p>' +
          '<p data-modal-price style="margin:0 0 4px;font-size:22px;font-weight:700;color:#9a5b34">' + money(up.netAfterTradeIn) + '</p>' +
          '<p data-modal-4x style="margin:0;font-size:12px;color:#7a6c58' + (up.netAfterTradeIn >= 20 ? '' : ';display:none') + '">ou 4× ' + money2(up.netAfterTradeIn / 4) + '/mois avec Alma</p>' +
          '<p data-modal-note style="margin:6px 0 10px;font-size:11px;color:#8a7d6b">' + money(up.fromPrice) + ' − ' + money(u.tradeIn) + ' reprise</p>' +
          '<a href="/products/' + encodeURIComponent(up.handle) + '?tradein=' + encodeURIComponent(state.modelLabel || '') + '" style="display:block;padding:10px;background:#9a5b34;color:#fff;text-decoration:none;border-radius:999px;text-align:center;font-weight:600;font-size:13px">Voir le ' + esc(up.label) + '</a>' +
        '</div>'
      ).join('');
      back.innerHTML =
        '<div style="background:#fff;border-radius:18px;max-width:680px;width:100%;' +
            'max-height:90vh;overflow:auto;padding:24px 22px;box-shadow:0 20px 60px rgba(0,0,0,.3)">' +
          '<p style="margin:0 0 4px;font-size:12px;color:#9a5b34;letter-spacing:1px;text-transform:uppercase">Un instant</p>' +
          '<h3 style="margin:0 0 8px;font-family:Georgia,serif;font-size:20px">' +
            'Votre ' + esc(state.modelLabel) + ' vaut ~' + money(u.tradeIn) +
            ' en reprise — votre réparation coûte <b>' + money(u.repairPrice) + '</b>.</h3>' +
          '<p style="margin:0 0 14px;font-size:14px;color:#5b5043">' +
            'Pour à peine plus, voici les modèles supérieurs en stock chez nous :</p>' +
          '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:12px">' + upgradeCards + '</div>' +
          '<a href="' + (root.getAttribute('data-shop-url') || '/collections/iphone') + '" ' +
            'style="display:block;width:100%;box-sizing:border-box;padding:12px;margin:0 0 10px;' +
            'background:#fff;color:#9a5b34;text-decoration:none;border:1.5px solid #9a5b34;' +
            'border-radius:999px;font-weight:600;text-align:center;font-size:14px">' +
            'Voir tous nos iPhone reconditionnés →</a>' +
          '<button type="button" data-bw-upsell-continue style="' +
            'display:block;width:100%;padding:13px;background:#fff;color:#2a2118;' +
            'border:1.5px solid #d9cdb7;border-radius:999px;font-weight:600;cursor:pointer;font-size:14px">' +
            'Non merci, je répare mon ' + esc(state.modelLabel) + ' (' + money(u.repairPrice) + ')</button>' +
          '<p style="margin:10px 0 0;font-size:11px;color:#8a7d6b;text-align:center">' +
            'Prix de reprise indicatifs, confirmés après diagnostic en atelier.</p>' +
        '</div>';
      document.body.appendChild(back);
      // Bouton "Continuer ma réparation" → ferme et avance.
      back.querySelector('[data-bw-upsell-continue]').addEventListener('click', function () {
        closeUpsellModal();
        buildSlots(); goTo(2);
      });
      // Click sur le fond noir → ferme + continue (UX standard).
      back.addEventListener('click', function (ev) {
        if (ev.target === back) { closeUpsellModal(); buildSlots(); goTo(2); }
      });
      // ESC pour fermer.
      function onKey(ev) {
        if (ev.key === 'Escape') {
          closeUpsellModal(); buildSlots(); goTo(2);
          document.removeEventListener('keydown', onKey);
        }
      }
      document.addEventListener('keydown', onKey);
      // Refine cards modal : ne conserve QUE les produits réellement en
      // stock côté Shopify, recale les prix sur la valeur boutique réelle.
      // Mode preview (file://) : on saute le check, sinon tout disparaît.
      if (window.location.protocol === 'file:' || !window.location.host) return;
      u.upgrades.forEach(up => {
        fetchShopifyInfo(up.handle, function (info) {
          const card = back.querySelector('[data-modal-upsell-card="' + cssEsc(up.handle) + '"]');
          if (!card) return;
          // On ne retire la carte QUE si le produit est explicitement en
          // rupture (hasStock===false). Si l'info est incertaine (null :
          // produit draft, 404, collection vide…), on GARDE la carte avec
          // son prix hardcodé — sinon le modal se vidait et se fermait tout
          // seul (bug 'pop-up qui apparaît puis disparaît'). On ne ferme
          // JAMAIS le modal automatiquement : les CTA 'Voir tous nos iPhone'
          // et 'Non merci' restent toujours présents.
          if (info.hasStock === false) {
            card.parentNode && card.parentNode.removeChild(card);
            return;
          }
          if (info.fromPrice != null && Math.abs(info.fromPrice - up.fromPrice) > 0.5) {
            up.fromPrice = info.fromPrice;
            up.netAfterTradeIn = Math.max(0, info.fromPrice - u.tradeIn);
            const priceEl = card.querySelector('[data-modal-price]');
            const noteEl  = card.querySelector('[data-modal-note]');
            const fourxEl = card.querySelector('[data-modal-4x]');
            if (priceEl) priceEl.textContent = money(up.netAfterTradeIn);
            if (noteEl)  noteEl.textContent  = money(up.fromPrice) + ' − ' + money(u.tradeIn) + ' reprise';
            if (fourxEl) {
              fourxEl.textContent = 'ou 4× ' + money2(up.netAfterTradeIn / 4) + '/mois avec Alma';
              fourxEl.style.display = up.netAfterTradeIn >= 20 ? '' : 'none';
            }
          }
        });
      });
    }
    function closeUpsellModal() {
      const m = document.querySelector('[data-bw-upsell-modal]');
      if (m) m.parentNode.removeChild(m);
    }

    // Total cumulé. Diagnostic dégât des eaux (29 €) compté une seule fois,
    // pas additionné aux autres pannes : il sera déduit du devis ferme si réparation.
    function recomputeTotal() {
      let sum = 0;
      state.issueIds.forEach(id => { sum += priceFor(id) || 0; });
      // Promo « 2 réparations = -20 % » : remise sur le total dès que le client
      // cumule au moins 2 VRAIES pannes. « Autre / je ne sais pas » n'est qu'un
      // diagnostic, pas une 2ᵉ réparation → exclu du décompte déclencheur.
      const repairCount = state.issueIds.filter(id => id !== 'other').length;
      state.multiRepair = multiRate > 0 && repairCount >= 2 && sum > 0;
      state.priceFull = sum || null;
      state.multiDiscount = state.multiRepair ? Math.round(sum * multiRate) : 0;
      state.price = sum ? sum - state.multiDiscount : null;

      const foot = $('[data-issues-foot]', s2);
      const totalEl = $('[data-issues-total]', s2);
      const fourxEl = $('[data-issues-fourx]', s2);
      const detailEl = $('[data-issues-detail]', s2);
      if (!state.issueIds.length) { foot.hidden = true; return; }
      foot.hidden = false;
      if (state.multiRepair) {
        totalEl.innerHTML = '<s class="bw-issues__strike">' + money(state.priceFull) +
          '</s> ' + money(state.price) +
          ' <span class="bw-issues__promo">' + promoLabel + '</span>';
      } else {
        totalEl.textContent = state.price != null ? money(state.price) : '—';
      }
      if (fourxEl) {
        fourxEl.textContent = state.price != null && state.price >= 20
          ? ' · 4× ' + money2(state.price / 4) + '/mois'
          : '';
      }
      detailEl.textContent = state.issueLabels.join(' + ') +
        (state.multiRepair ? ' · remise 2 réparations appliquée' : '');
    }

    function computeUpsell() {
      if (!state.fam || !state.price) return null;
      const key = upgradeKey(state.modelLabel, state.fam);
      const targets = UPGRADE[key] || UPGRADE[state.fam] || [];
      const inStock = targets.filter(t => t.inStock);
      if (!inStock.length) return null;
      // Valeur reprise : priorité au prix BackMarket (cache), sinon grille interne.
      const bmValue = bmValueCache[state.modelLabel];
      const value = (bmValue && bmValue > 0) ? bmValue : VALUE_BY_FAMILY[state.fam];
      if (!value) return null;
      // Coef appliqué = produit des coefs des pannes cochées (chaque panne pèse).
      let coef = 1.0;
      state.issueIds.forEach(id => {
        const c = VALUE_COEF_BY_ISSUE[id] != null ? VALUE_COEF_BY_ISSUE[id] : 0.85;
        coef *= c;
      });
      coef = Math.max(0.20, coef);
      const tradeIn = Math.max(20, Math.round((value * coef) / 5) * 5);
      const ratio = state.price / value;
      if (ratio < UPSELL_THRESHOLD) return null;
      const upgrades = inStock.map(t => ({
        handle: t.handle,
        label: t.label,
        fromPrice: t.fromPrice,
        netAfterTradeIn: Math.max(0, t.fromPrice - tradeIn)
      }));
      return {
        deviceValue: value,
        tradeIn: tradeIn,
        repairPrice: state.price,
        upgrades: upgrades
      };
    }

    function renderUpsell(u) {
      removeUpsell();
      const c = document.createElement('div');
      c.className = 'bw-upsell';
      c.setAttribute('data-bw-upsell', '');
      c.setAttribute('role', 'region');
      c.setAttribute('aria-label', 'Suggestion : passer à un modèle supérieur');
      const upgradeCards = u.upgrades.map((up, i) =>
        '<div class="bw-upsell__card' + (i === 0 ? ' bw-upsell__card--best' : '') + '" data-upsell-card="' + esc(up.handle) + '">' +
          (i === 0 ? '<span class="bw-upsell__tag">Recommandé</span>' : '') +
          '<span class="bw-upsell__stock" data-stock-badge>En stock</span>' +
          '<p class="bw-upsell__card-lbl">' + esc(up.label) + '</p>' +
          '<p class="bw-upsell__card-price">' + money(up.netAfterTradeIn) + '</p>' +
          (up.netAfterTradeIn >= 20 ? '<p class="bw-upsell__card-4x">ou 4× ' + money2(up.netAfterTradeIn / 4) + '/mois avec Alma</p>' : '') +
          '<p class="bw-upsell__card-note">' + money(up.fromPrice) + ' − ' + money(u.tradeIn) + ' reprise</p>' +
          '<a href="/products/' + encodeURIComponent(up.handle) + '?tradein=' + encodeURIComponent(state.modelLabel || '') + '" class="btn btn--accent btn--sm btn--block">Voir le ' + esc(up.label) + '</a>' +
        '</div>'
      ).join('');
      c.innerHTML =
        '<p class="bw-upsell__eyebrow">Un instant — réparer, ou changer ?</p>' +
        '<h4 class="bw-upsell__title">Votre ' + esc(state.modelLabel) + ' vaut ~' + money(u.tradeIn) +
          ' en reprise, votre réparation coûte <b>' + money(u.repairPrice) + '</b>. ' +
          'Pour à peine plus, voici les modèles en stock dans notre boutique :</h4>' +
        '<div class="bw-upsell__cards">' +
          '<div class="bw-upsell__card bw-upsell__card--repair">' +
            '<p class="bw-upsell__card-lbl">Je répare mon ' + esc(state.modelLabel) + '</p>' +
            '<p class="bw-upsell__card-price">' + money(u.repairPrice) + '</p>' +
            (u.repairPrice >= 20 ? '<p class="bw-upsell__card-4x">ou 4× ' + money2(u.repairPrice / 4) + '/mois avec Alma</p>' : '') +
            '<p class="bw-upsell__card-note">Devis indicatif, garantie 12 mois.</p>' +
            '<button type="button" class="btn btn--ghost btn--sm btn--block" data-bw-continue>Continuer ma réparation</button>' +
          '</div>' +
          upgradeCards +
        '</div>' +
        '<p class="bw-upsell__finepr">Prix de reprise indicatifs — confirmés après diagnostic en atelier. ' +
          '« En stock » = disponibilité au moment où vous regardez, peut varier.</p>';
      // Injecte sous l'encart total.
      const foot = $('[data-issues-foot]', s2);
      // Insère l'upsell AU-DESSUS du foot (au-dessus du total + bouton),
      // pour qu'il soit visible immédiatement sans scroll supplémentaire.
      foot.parentNode.insertBefore(c, foot);
      c.querySelector('[data-bw-continue]').addEventListener('click', function () {
        removeUpsell();
        if (state.issueIds.length) { buildSlots(); goTo(2); }
      });
      // Pas de scrollIntoView ici : re-render à chaque clic de panne → la page
      // sautait de façon déroutante. L'upsell s'affiche en place, sans yank.
      // Refine : ne conserve QUE les produits réellement en stock côté
      // Shopify, recale les prix sur la valeur boutique réelle.
      // Mode preview (file://) : on saute le check.
      if (window.location.protocol === 'file:' || !window.location.host) return;
      u.upgrades.forEach(up => {
        fetchShopifyInfo(up.handle, function (info) {
          const card = c.querySelector('[data-upsell-card="' + cssEsc(up.handle) + '"]');
          if (!card) return;
          // Idem modal : on ne retire que sur rupture explicite (false), pas
          // sur info incertaine (null = draft/404). On ne supprime jamais
          // tout l'encart automatiquement.
          if (info.hasStock === false) {
            card.parentNode && card.parentNode.removeChild(card);
            return;
          }
          if (info.fromPrice != null && Math.abs(info.fromPrice - up.fromPrice) > 0.5) {
            up.fromPrice = info.fromPrice;
            up.netAfterTradeIn = Math.max(0, info.fromPrice - u.tradeIn);
            const priceEl = card.querySelector('.bw-upsell__card-price');
            const noteEl  = card.querySelector('.bw-upsell__card-note');
            const fourxEl = card.querySelector('.bw-upsell__card-4x');
            if (priceEl) priceEl.textContent = money(up.netAfterTradeIn);
            if (noteEl)  noteEl.textContent  = money(up.fromPrice) + ' − ' + money(u.tradeIn) + ' reprise';
            if (fourxEl) fourxEl.textContent = 'ou 4× ' + money2(up.netAfterTradeIn / 4) + '/mois avec Alma';
          }
        });
      });
    }
    function cssEsc(s) { return String(s).replace(/"/g, '\\"'); }

    // Cache de session pour ne pas hammer le Storefront à chaque step.
    // Renvoie { hasStock: bool|null, fromPrice: number|null } pour permettre
    // aux cards upsell de se réaligner sur le prix RÉEL boutique (et non sur
    // la valeur hardcodée du tableau UPGRADE).
    function fetchShopifyInfo(handle, cb) {
      if (!handle) return cb({ hasStock: null, fromPrice: null });
      // En preview standalone (file://, hôte vide) on n'a pas de backend.
      if (window.location.protocol === 'file:' || !window.location.host) {
        return cb({ hasStock: null, fromPrice: null });
      }
      const cacheKey = 'iphumat_shopinfo_' + handle;
      try {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached !== null) {
          const parsed = JSON.parse(cached);
          return cb(parsed);
        }
      } catch (_) {}
      // On interroge d'abord le PRODUIT (handle = produit Shopify, comme
      // iphone-13-reconditionne) ; si 404 on retombe sur la collection
      // homonyme — utile pour les futurs handles de collection.
      fetch('/products/' + encodeURIComponent(handle) + '.js',
            { headers:{Accept:'application/json'} })
        .then(r => r.ok ? r.json().catch(() => null) : null)
        .then(prod => {
          if (prod && prod.variants && prod.variants.length) {
            let minAvail = null, minAny = null, hasStock = false;
            prod.variants.forEach(v => {
              // /products/<handle>.js : v.price est en CENTIMES.
              const price = (typeof v.price === 'number' ? v.price / 100 : parseFloat(v.price));
              if (!isNaN(price)) {
                if (minAny == null || price < minAny) minAny = price;
                if (v.available) {
                  hasStock = true;
                  if (minAvail == null || price < minAvail) minAvail = price;
                }
              }
            });
            const r = { hasStock: hasStock, fromPrice: (minAvail != null ? minAvail : minAny) };
            try { sessionStorage.setItem(cacheKey, JSON.stringify(r)); } catch (_) {}
            cb(r);
            return;
          }
          // Pas de produit → fallback collection (handle peut être un
          // regroupement, comme mac-reconditionnes).
          fetchShopifyInfoCollection(handle, cacheKey, cb);
        })
        .catch(() => fetchShopifyInfoCollection(handle, cacheKey, cb));
    }
    function fetchShopifyInfoCollection(handle, cacheKey, cb) {
      fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=50',
            { headers:{Accept:'application/json'} })
        .then(r => r.ok ? r.json().catch(() => null) : null)
        .then(data => {
          if (!data) { cb({ hasStock: null, fromPrice: null }); return; }
          const products = data.products || [];
          if (products.length === 0) {
            cb({ hasStock: null, fromPrice: null });
            return;
          }
          let minAvail = null, minAny = null;
          let hasStock = false;
          products.forEach(p => (p.variants || []).forEach(v => {
            const price = parseFloat(v.price);
            if (!isNaN(price)) {
              if (minAny == null || price < minAny) minAny = price;
              if (v.available) {
                hasStock = true;
                if (minAvail == null || price < minAvail) minAvail = price;
              }
            }
          }));
          const r = { hasStock: hasStock, fromPrice: (minAvail != null ? minAvail : minAny) };
          try { sessionStorage.setItem(cacheKey, JSON.stringify(r)); } catch (_) {}
          cb(r);
        })
        .catch(() => cb({ hasStock: null, fromPrice: null }));
    }
    // Compat : ancien call-site qui n'avait besoin que du booléen.
    function fetchShopifyStock(handle, cb) {
      fetchShopifyInfo(handle, function (info) { cb(info.hasStock); });
    }
    function removeUpsell() {
      const old = $('[data-bw-upsell]', s2);
      if (old && old.parentNode) old.parentNode.removeChild(old);
    }

    // Réparation à distance : affiche le sélecteur « atelier / à distance »
    // (dormant si non activé), bascule les panneaux et permet de continuer
    // sans RDV. Idempotent (ne câble qu'une fois).
    function wireDelivery() {
      const box = $('[data-bw-delivery]', s3);
      if (!box || box._wired) return;
      box._wired = true;
      box.hidden = false;
      const feeEl = $('[data-bw-mailin-fee]', s3);
      if (feeEl) feeEl.textContent = 'supplément ' + money(mailinFee) + ' aller-retour';
      const slotsPanel  = $('[data-bw-slots-panel]', s3);
      const mailinPanel = $('[data-bw-mailin-panel]', s3);
      function apply(mode) {
        state.deliveryType = (mode === 'mail_in') ? 'mail_in' : 'in_shop';
        $$('[data-bw-delivery-opt]', box).forEach(function (b) {
          const on = b.getAttribute('data-bw-delivery-opt') === state.deliveryType;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (slotsPanel)  slotsPanel.hidden  = (state.deliveryType === 'mail_in');
        if (mailinPanel) mailinPanel.hidden = (state.deliveryType !== 'mail_in');
        updateRecap();
      }
      $$('[data-bw-delivery-opt]', box).forEach(function (b) {
        b.addEventListener('click', function () { apply(b.getAttribute('data-bw-delivery-opt')); });
      });
      const cont = $('[data-bw-mailin-continue]', s3);
      if (cont) cont.addEventListener('click', function () { goTo(3); });
      apply(state.deliveryType || 'in_shop');
    }

    // Step 3: slot picker — fetch busy slots from Odoo (← Google Calendar sync).
    let days = [];
    function buildSlots() {
      days = nextDays(7);
      const daysEl  = $('[data-bw-days]', s3);
      const timesEl = $('[data-bw-times]', s3);
      const chosen  = $('[data-bw-chosen]', s3);
      if (mailinEnabled) wireDelivery();
      daysEl.innerHTML = days.map((d, i) =>
        '<button type="button" class="slots__day" data-bw-day="' + i + '">' +
          '<span class="slots__day-lbl">' + DAY_LBL[d.getDay()] + '</span>' +
          '<span class="slots__day-num">' + d.getDate() + '</span>' +
          '<span class="slots__day-mon">' + MONTHS[d.getMonth()] + '</span>' +
        '</button>'
      ).join('');
      timesEl.innerHTML = '';
      chosen.textContent = '';
      // Charge la dispo réelle (async, non bloquant : la grille s'affiche, les indispos sont
      // marquées dès que la réponse arrive).
      fetchBusy();
      $$('[data-bw-day]', daysEl).forEach(b => b.addEventListener('click', function () {
        state.dayIdx = parseInt(b.getAttribute('data-bw-day'), 10);
        $$('[data-bw-day]', daysEl).forEach(x => x.classList.toggle('is-active', x === b));
        renderTimes();
      }));
      function renderTimes() {
        const d = days[state.dayIdx];
        const dayKey = d.getFullYear() + '-' + pad(d.getMonth()+1) + '-' + pad(d.getDate());
        // Pour aujourd'hui : on grise les heures déjà passées (+ délai de
        // préparation). À 17h30, 10h-17h sont 'trop tard', 18h/18h30 OK.
        const now = new Date();
        const isToday = d.toDateString() === now.toDateString();
        const cutoffMin = now.getHours() * 60 + now.getMinutes() + SLOT_LEAD_MIN;
        let availCount = 0;
        const html = TIMES.map(t => {
          const parts = t.split(':');
          const tMin = parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
          const tooLate = isToday && tMin < cutoffMin;
          // Heures déjà passées : on ne les affiche PAS du tout (inutile de
          // montrer un créneau barré 'trop tard', ça encombre la grille).
          if (tooLate) return '';
          const busy = isBusy(dayKey, t);
          if (!busy) availCount++;
          // Créneau occupé par un autre RDV (calendrier atelier) : affiché
          // mais grisé 'indisponible' — info utile (réservé, pas passé).
          return '<button type="button" class="slots__time' + (busy ? ' is-unavailable' : '') +
            '" data-bw-time="' + t + '"' + (busy ? ' disabled aria-label="Indisponible"' : '') + '>' +
            t + (busy ? '<small>indisponible</small>' : '') + '</button>';
        }).join('');
        timesEl.innerHTML = (availCount === 0)
          ? '<p class="slots__empty">Plus de créneau disponible ce jour — choisissez une autre date.</p>' + html
          : html;
        $$('[data-bw-time]', timesEl).forEach(b => b.addEventListener('click', function () {
          if (b.disabled) return;
          state.time = b.getAttribute('data-bw-time');
          $$('[data-bw-time]', timesEl).forEach(x => x.classList.toggle('is-active', x === b));
          state.slotIso = dayKey + 'T' + state.time;
          state.slotLbl = fmtDate(d) + ' à ' + state.time;
          chosen.textContent = 'Créneau choisi : ' + state.slotLbl;
          updateRecap();
          setTimeout(() => goTo(3), 250);
        }));
      }
    }
    function fetchBusy() {
      if (!slotsEndpoint) return;
      fetch(slotsEndpoint + (slotsEndpoint.indexOf('?') >= 0 ? '&' : '?') + 'days=7', { headers:{Accept:'application/json'} })
        .then(r => r.json()).then(res => {
          if (res && res.ok && Array.isArray(res.busy)) {
            busySlots = res.busy;
            // Si la grille de l'heure est déjà rendue, on rafraîchit.
            if (state.dayIdx >= 0) {
              const ev = new Event('click');
              const dayBtn = $('[data-bw-day="' + state.dayIdx + '"]', s3);
              if (dayBtn) dayBtn.dispatchEvent(ev);
            }
          }
        }).catch(() => {});
    }
    function isBusy(dayKey, time) {
      // Slot couvre 1h. Conflit si chevauchement.
      const slotStart = new Date(dayKey + 'T' + time + ':00');
      const slotEnd = new Date(slotStart.getTime() + 60 * 60 * 1000);
      for (let i = 0; i < busySlots.length; i++) {
        const b = busySlots[i];
        const bs = new Date(b.start);
        const be = new Date(b.stop);
        if (bs < slotEnd && be > slotStart) return true;
      }
      return false;
    }
    function pad(n) { return String(n).padStart(2, '0'); }

    // Step 4: toggle Particulier / Professionnel
    s4.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-ctype]'); if (!btn) return;
      state.clientType = btn.getAttribute('data-ctype');
      $$('[data-ctype]', s4).forEach(b => {
        const on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const pro = $('[data-pro-fields]', s4);
      if (pro) {
        const isPro = state.clientType === 'pro';
        pro.hidden = !isPro;
        // Required dynamique : sinon le validator du navigateur ignore.
        const compInput = pro.querySelector('input[name="company"]');
        if (compInput) {
          if (isPro) compInput.setAttribute('required', 'required');
          else compInput.removeAttribute('required');
        }
      }
    });

    // Step 4: contact + submit
    const formWrap = s4;
    formWrap.addEventListener('submit', function (e) {
      const form = e.target.closest('[data-bw-form]'); if (!form) return;
      e.preventDefault();
      const el = form.elements;
      state.first_name = el['first_name'].value.trim();
      state.last_name = el['last_name'].value.trim();
      state.email = el['email'].value.trim();
      state.phone = el['phone'].value.trim();
      state.company = el['company'].value.trim();
      state.address = el['address'].value.trim();
      state.message = el['message'].value.trim();
      state.name = (state.first_name + ' ' + state.last_name).trim();
      const honey = el['website'].value;
      if (!state.first_name || !state.last_name || !state.email) { setStatus('Indiquez prénom, nom et un email valide.', 'error'); return; }
      // Validation téléphone FR : 10 chiffres commençant par 0, OU format
      // E.164 (+33...). Aligne avec la validation côté reprise.
      var phoneOk = /^0\d{9}$/.test(state.phone.replace(/[\s.\-]/g, ''))
                    || /^\+\d{10,14}$/.test(state.phone.replace(/[\s.\-]/g, ''));
      if (!phoneOk) { setStatus('Téléphone invalide. Format attendu : 0612345678.', 'error'); return; }
      if (state.clientType === 'pro' && !state.company) { setStatus('Indiquez le nom de votre société.', 'error'); return; }
      if (!endpoint) { setStatus(contactFallbackMsg(), 'error'); reportOutage('no_endpoint', 'data-endpoint vide dans le thème'); return; }
      // Anti-doublon UX : si le client a déjà une réservation en cours dans
      // la fenêtre serveur, on lui demande confirmation avant de re-créer un
      // bon (cas légitime = 2e appareil ; sinon on évite le triple-clic).
      checkPending(state.email, state.phone, function (pending) {
        if (pending && pending.has) {
          var ref = pending.reference || '';
          var when = pending.when ? (' pour le ' + pending.when) : '';
          var model = pending.model ? (' (' + pending.model + ')') : '';
          showDuplicateModal(pending, function (continueAnyway) {
            if (continueAnyway) {
              submit(form, honey, true);
            } else {
              setStatus('Réservation existante conservée — réf. '
                + (pending.reference || '') + '.', '');
            }
          });
          return;
          /* legacy window.confirm() bloc supprimé au profit de showDuplicateModal :
            'Vous avez déjà une réservation en cours' + when + model +
            (ref ? ' — réf. ' + ref : '') + '.\n\n' +
            'Souhaitez-vous quand même créer une 2ᵉ réservation ?\n\n' +
            '✔ OK = ajouter une nouvelle réparation\n' +
            '✘ Annuler = garder uniquement la réservation existante');
          if (!ok) {
            setStatus('Réservation existante conservée — réf. ' + ref + '.', '');
            return;
          }
          submit(form, honey, true);
          return; */
        }
        submit(form, honey, false);
      });
    });

    function checkPending(email, phone, cb) {
      // Dérive l'URL has_pending depuis l'endpoint POST (même origine, même
      // proxy le cas échéant).
      var url = endpoint.replace(/\/booking\/?$/, '/booking/has_pending');
      if (url === endpoint) { return cb(null); }
      var qs = [];
      if (email) qs.push('email=' + encodeURIComponent(email));
      if (phone) qs.push('phone=' + encodeURIComponent(phone));
      fetch(url + '?' + qs.join('&'), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (j) { cb(j && j.ok ? j : null); })
        .catch(function () { cb(null); }); // échec silencieux : on poste quand même
    }

    // Modal custom anti-doublon (remplace window.confirm() qui cassait l'UX).
    // Accessible : ESC + click backdrop + focus auto sur le bouton primaire.
    function showDuplicateModal(pending, cb) {
      if (document.querySelector('[data-bw-dup-modal]')) return;
      var ref = pending.reference || '';
      var whenStr = pending.when ? ' pour le ' + pending.when : '';
      var modelStr = pending.model ? ' (' + pending.model + ')' : '';
      var back = document.createElement('div');
      back.setAttribute('data-bw-dup-modal', '');
      back.setAttribute('role', 'dialog');
      back.setAttribute('aria-modal', 'true');
      back.style.cssText = 'position:fixed;inset:0;background:rgba(42,33,24,.55);' +
        'z-index:9999;display:flex;align-items:center;justify-content:center;' +
        'padding:16px;animation:bwFadeIn .15s ease';
      back.innerHTML =
        '<div style="background:#fff;border-radius:18px;max-width:460px;width:100%;' +
            'padding:24px 26px;box-shadow:0 20px 60px rgba(0,0,0,.3);' +
            'font-family:Helvetica,Arial,sans-serif">' +
          '<p style="margin:0 0 4px;font-size:12px;color:#9a5b34;letter-spacing:1px;' +
              'text-transform:uppercase">Réservation existante</p>' +
          '<h3 style="margin:0 0 10px;font-family:Georgia,serif;font-size:20px;color:#2a2118">' +
            'Vous avez déjà une réservation en cours' + esc(whenStr) + '.</h3>' +
          (ref ? '<p style="margin:0 0 6px;font-size:14px;color:#5b5043">' +
                 'Référence : <b>' + esc(ref) + '</b>' + esc(modelStr) + '</p>' : '') +
          '<p style="margin:14px 0 16px;font-size:14px;color:#5b5043;line-height:1.6">' +
            'Souhaitez-vous quand même créer une <b>nouvelle réservation</b> ' +
            '(par exemple pour un autre appareil) ?</p>' +
          '<div style="display:flex;gap:10px;flex-direction:column">' +
            '<button type="button" data-dup-continue style="padding:13px;' +
              'background:#9a5b34;color:#fff;border:0;border-radius:999px;' +
              'font-weight:600;cursor:pointer;font-size:14px">' +
              'Ajouter une nouvelle réparation</button>' +
            '<button type="button" data-dup-cancel style="padding:13px;' +
              'background:#fff;color:#2a2118;border:1.5px solid #d9cdb7;' +
              'border-radius:999px;font-weight:600;cursor:pointer;font-size:14px">' +
              'Garder uniquement la réservation existante</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(back);
      function close(result) {
        document.removeEventListener('keydown', onKey);
        if (back.parentNode) back.parentNode.removeChild(back);
        cb(result);
      }
      function onKey(ev) { if (ev.key === 'Escape') close(false); }
      document.addEventListener('keydown', onKey);
      back.addEventListener('click', function (ev) {
        if (ev.target === back) close(false);
      });
      back.querySelector('[data-dup-continue]').addEventListener(
        'click', function () { close(true); });
      back.querySelector('[data-dup-cancel]').addEventListener(
        'click', function () { close(false); });
      back.querySelector('[data-dup-cancel]').focus();  // bouton "safe" par défaut
    }

    function submit(form, honey, force) {
      // Le contrôleur Odoo attend un issue_type unique : on prend le 1er, et la liste
      // complète passe dans le message (note interne, traçable, contrôlée serveur).
      const primaryIssue = state.issueIds[0] || 'other';
      const payload = {
        name: state.name,
        first_name: state.first_name, last_name: state.last_name,
        email: state.email, phone: state.phone,
        company: state.company, address: state.address,
        device_model: state.modelLabel,
        issue_type: primaryIssue,
        issue_types: state.issueIds,
        // Gamme d'écran choisie (uniquement pertinent si « écran » fait partie
        // des pannes) → permet à Odoo de poser la bonne pièce + le bon prix.
        quality: (state.issueIds.indexOf('screen') >= 0 ? screenQuality : ''),
        // Teinte d'origine (uniquement pertinente si « vitre arrière » fait
        // partie des pannes) → Odoo commande et pose le bon châssis / la
        // bonne vitre, sans rappeler le client.
        back_color: (state.issueIds.indexOf('back') >= 0
          ? (state.backColor || '') : ''),
        requested_slot: (state.deliveryType === 'mail_in' ? '' : state.slotIso),
        delivery_type: state.deliveryType,
        price_quote: (state.price != null && state.deliveryType === 'mail_in'
          ? state.price + mailinFee : state.price),
        upsell_shown: state.upsellShown,
        message: composeMessage(),
        website: honey,
        force: !!force
      };
      const headers = { 'Content-Type': 'application/json' };
      setStatus('Envoi en cours…', '');
      lockSubmit(form, true);

      // Codes signifiant « token absent/périmé » → on récupère un token frais
      // et on réessaie UNE fois (auto-réparation).
      const AUTH_FAIL = { unauthorized: 1, client_secret_missing: 1, secret_mismatch: 1 };

      function fail(code, res) {
        setStatus(messageFor(code), 'error');
        if (code !== 'missing_contact') {
          reportOutage(code || ('http_' + ((res && res.status) || '?')),
                       JSON.stringify((res && res.body) || {}));
        }
        lockSubmit(form, false);
      }

      // Pannes PASSAGÈRES (Odoo qui redémarre pendant un déploiement, coupure
      // réseau du client) : Odoo renvoie alors une page d'erreur HTML en 5xx,
      // pas du JSON. Plutôt que de perdre la réservation, on RÉESSAIE en
      // silence avec un petit délai — un redémarrage dure quelques secondes.
      const RETRY_DELAYS = [2000, 5000, 9000];
      function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

      function sendWith(tok, canHeal, attempt) {
        attempt = attempt || 0;
        payload.token = tok || '';
        return fetch(endpoint, { method: 'POST', headers: headers, body: JSON.stringify(payload) })
          .then(r => r.json().catch(() => ({})).then(j => ({ ok: r.ok, status: r.status, body: j })))
          .then(res => {
            if (res.ok && res.body && res.body.ok) {
              renderSuccess(res.body);
              goTo(4);
              return;
            }
            const code = res.body && res.body.error;
            // Serveur momentanément indisponible (5xx sans code d'erreur métier)
            // → nouvelle tentative, sans inquiéter le client ni alerter l'équipe.
            if (!code && res.status >= 500 && attempt < RETRY_DELAYS.length) {
              setStatus('Serveur momentanément occupé, nouvelle tentative…', '');
              return wait(RETRY_DELAYS[attempt])
                .then(function () { return sendWith(tok, canHeal, attempt + 1); });
            }
            // Token refusé → on va chercher un token valide chez Odoo et on
            // réessaie (une seule fois, pas de boucle).
            if (canHeal && AUTH_FAIL[code]) {
              return fetchFreshToken().then(function (fresh) {
                if (fresh && fresh !== tok) { return sendWith(fresh, false, attempt); }
                fail(code, res);
              }, function () { fail(code, res); });
            }
            if (code === 'missing_contact') {
              setStatus(messageFor(code), 'error');
              lockSubmit(form, false);
            } else {
              fail(code, res);
            }
          })
          .catch(() => {
            // Échec réseau : même politique de réessai avant d'abandonner.
            if (attempt < RETRY_DELAYS.length) {
              setStatus('Connexion interrompue, nouvelle tentative…', '');
              return wait(RETRY_DELAYS[attempt])
                .then(function () { return sendWith(tok, canHeal, attempt + 1); });
            }
            setStatus(contactFallbackMsg(), 'error');
            reportOutage('connection', 'fetch failed après ' + RETRY_DELAYS.length + ' réessais');
            lockSubmit(form, false);
          });
      }

      sendWith(runtimeToken || secret, true);
    }
    function composeMessage() {
      const lines = [
        'Modèle : ' + state.modelLabel,
        'Panne(s) : ' + state.issueLabels.join(', ')
      ];
      if (state.multiRepair && state.multiDiscount) {
        lines.push('Sous-total : ' + money(state.priceFull));
        lines.push('Remise 2 réparations : ' + promoLabel + ' (-' + money(state.multiDiscount) + ')');
      }
      lines.push('Devis indicatif : ' + (state.price != null ? money(state.price) : '—'));
      lines.push('Créneau souhaité : ' + (state.slotLbl || '—'));
      if (state.message) lines.push('Message client : ' + state.message);
      return lines.join('\n');
    }
    function renderSuccess(body) {
      const ref = body.reference || '—';
      const trk = (body.tracking_token ? (trackUrl + '?token=' + encodeURIComponent(body.tracking_token)) : trackUrl);
      $('[data-bw-success]', s5).innerHTML =
        '<div class="bw-success">' +
          '<div class="bw-success__check" aria-hidden="true">✓</div>' +
          '<h3>Réservation confirmée — réf. ' + ref + '</h3>' +
          '<p>Confirmation envoyée à <b>' + esc(state.email) + '</b>. On vous attend ' + esc(state.slotLbl || '') + '.</p>' +
          '<div class="bw-success__cta">' +
            '<a href="' + trk + '" class="btn btn--accent btn--lg">Suivre ma réparation</a>' +
            '<button type="button" class="btn btn--ghost btn--lg" data-bw-restart>Nouvelle réservation</button>' +
          '</div>' +
        '</div>';
      $('[data-bw-restart]', s5).addEventListener('click', restart);
    }

    // Recap sticky
    function updateRecap() {
      // Total affiché = estimation réparation + supplément envoi si à distance.
      var totalPrice = state.price;
      var fullPrice  = state.priceFull;
      if (totalPrice != null && state.deliveryType === 'mail_in') totalPrice += mailinFee;
      if (fullPrice  != null && state.deliveryType === 'mail_in') fullPrice  += mailinFee;
      recap.model.textContent   = state.modelLabel || '—';
      recap.issue.textContent   = (state.issueLabels.length
        ? state.issueLabels.join(', ')
          + (state.backColor ? ' — couleur : ' + state.backColor : '')
        : '—');
      if (state.multiRepair && totalPrice != null) {
        recap.price.innerHTML = '<s class="bw-recap__strike">' + money(fullPrice) +
          '</s> ' + money(totalPrice) + ' <span class="bw-recap__promo">' + promoLabel + '</span>';
      } else {
        recap.price.textContent = totalPrice != null ? money(totalPrice) : '—';
      }
      if (recap.fourx) {
        recap.fourx.textContent = totalPrice != null && totalPrice >= 20
          ? 'soit 4× ' + money2(totalPrice / 4) + '/mois'
          : '';
      }
      recap.slot.textContent    = (state.deliveryType === 'mail_in')
        ? 'Réparation à distance (envoi postal)'
        : (state.slotLbl || '—');
      if (recap.contact) recap.contact.textContent = state.name ? (state.name + (state.email ? ' · ' + state.email : '')) : '—';
    }

    // Navigation
    stepsEl.addEventListener('click', function (e) {
      if (e.target.matches('[data-bw-back]')) goTo(Math.max(0, stepIdx - 1));
    });

    function goTo(i) {
      stepIdx = i;
      $$('.bw-step', stepsEl).forEach((s, idx) => { s.hidden = idx !== i; });
      if (progressEl) progressEl.style.width = ((i + 1) / 5 * 100) + '%';
      // Pas d'autofocus au changement d'étape : sur iOS/Safari, focus() ignore
      // souvent preventScroll → la page saute vers le champ (souvent en bas) et
      // le clavier s'ouvre. On se contente de remonter en haut du wizard.
      if (!goTo._first) { goTo._first = true; return; }
      // Scroll déterministe vers le haut du wizard (plus fiable que
      // scrollIntoView smooth sur iOS). On attend le rendu (rAF) pour mesurer.
      requestAnimationFrame(function () {
        try {
          var top = root.getBoundingClientRect().top + window.pageYOffset - 12;
          window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        } catch (_) {
          try { root.scrollIntoView({ behavior: 'auto', block: 'start' }); } catch (e) {}
        }
      });
    }
    function restart() {
      state.modelId = state.modelLabel = state.fam = '';
      state.issueIds = []; state.issueLabels = []; state.price = null;
      state.backColor = '';
      state.priceFull = null; state.multiDiscount = 0; state.multiRepair = false;
      state.dayIdx = -1; state.time = ''; state.slotIso = ''; state.slotLbl = '';
      state.name = state.email = state.phone = state.message = '';
      state.first_name = state.last_name = state.company = state.address = '';
      state.upsellShown = false;
      $$('.is-active', stepsEl).forEach(b => b.classList.remove('is-active'));
      $$('[data-pick-issue]', stepsEl).forEach(cb => { cb.checked = false; });
      updateRecap();
      goTo(0);
    }
    goTo(0);
    updateRecap();
    // Pré-remplissage via URL (?model=iphone-13&issues=screen,back)
    // utilisé notamment par le cross-sell depuis le wizard reprise.
    initFromUrl();

    function initFromUrl() {
      let params;
      try { params = new URLSearchParams(window.location.search); } catch (_) { return; }
      const modelId = params.get('model');
      const issuesRaw = params.get('issues') || '';
      if (!modelId) return;
      const meta = MODELS.find(x => x.id === modelId);
      if (!meta) return;
      state.modelId = modelId;
      state.modelLabel = meta.label;
      state.fam = meta.fam;
      const btn = stepsEl.querySelector('[data-pick-model="' + modelId + '"]');
      if (btn) btn.classList.add('is-active');
      buildIssues();
      const ids = issuesRaw.split(',').map(s => s.trim()).filter(Boolean);
      ids.forEach(id => {
        const cb = s2.querySelector('[data-pick-issue="' + id + '"]');
        if (cb) {
          cb.checked = true;
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      updateRecap();
      goTo(1);
    }

    function setStatus(msg, kind) {
      const el = $('[data-bw-status]', s4);
      if (!el) return;
      el.textContent = msg; el.className = 'booking__status' + (kind ? ' is-' + kind : '');
    }
    function lockSubmit(form, on) {
      const btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = on; btn.style.opacity = on ? '.6' : ''; }
    }
    // Message de repli quand la réservation en ligne ne passe pas : on ne
    // laisse JAMAIS le client dans une impasse — on donne le téléphone + email
    // pour qu'il nous joigne directement.
    function contactFallbackMsg() {
      return "Notre réservation en ligne est momentanément indisponible. "
        + "Appelez-nous au " + contactPhone + " ou écrivez à " + contactEmail
        + " — on prend en charge votre appareil directement. Désolé pour la gêne !";
    }
    // Prévient l'équipe en temps réel qu'un client a échoué à réserver (panne
    // probable). sendBeacon = envoi « simple » (pas de préflight CORS), non
    // bloquant, part même si la page se ferme. Le serveur limite à 1 mail /
    // 15 min pour ne pas spammer.
    function reportOutage(reason, detail) {
      try {
        if (!alertEndpoint || typeof navigator === 'undefined' || !navigator.sendBeacon) return;
        var blob = new Blob(
          [JSON.stringify({ reason: reason || '', detail: (detail || '').slice(0, 400) })],
          { type: 'text/plain' });
        navigator.sendBeacon(alertEndpoint, blob);
      } catch (e) { /* best-effort */ }
    }
    function messageFor(code) {
      switch (code) {
        case 'missing_contact': return 'Indiquez votre nom et un email ou téléphone.';
        // unauthorized / invalid_json / inconnu = panne côté service → on
        // bascule sur le message de contact (et on alerte l'équipe).
        default:                return contactFallbackMsg();
      }
    }
    function esc(s) { return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

    // Builders
    function stepEl(title, sub, html) {
      const w = document.createElement('div');
      w.className = 'bw-step'; w.hidden = true;
      w.innerHTML =
        '<header class="bw-step__head"><h3 class="bw-step__title">' + title + '</h3>' +
        (sub ? '<p class="bw-step__sub">' + sub + '</p>' : '') + '</header>' +
        html +
        '<div class="bw-step__nav"><button type="button" class="link-back" data-bw-back>← Retour</button></div>';
      return w;
    }
    function renderModels() {
      return '<div class="rep-chips rep-chips--wrap">' +
        MODELS.map(m => '<button type="button" class="rep-chip" data-pick-model="' + m.id + '">' + m.label + '</button>').join('') +
        '</div>';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-booking-wizard]').forEach(init);
  });
})();
